export const Globals = {
  CAROUSAL_TIME_INTERVAL_: 5000,
  BASE_URL: '',
  CAROUSAL_TIME_INTERVAL: 60000,
  JWT_TOKEN_NAME: "jwtToken",
  JWT_TOKEN_EXPIRY: 8,
  TXT_AREA_MAX_CHARS_LIMIT: 1024,
  CANCEL: "Cancel",
  NAVPATH: {
    ROOT: "/",
    HELP_VIDEOS: "/help-videos",
    SIGNUP: "/register",
    RESET_PASSWORD: "/reset-password/:activationToken",
    HOME: "/home",
    EDITCOMPANY: "/edit-company",
    EDITPRODUCER: "/edit-producer",
    PRODUCER_SIGNUP: "/producer-registration",
    CREATE_UNSOLICITED: "/create-unsolicited",
    EDIT_UNSOLICITED: "/edit-unsolicited",
    COMPANY_SIGNUP: "/company-registration",
    PDF_READER: "/pdf-reader",
    FAQ: "/faq",
    TICKETS: "/tickets",
    RAISE_TICKET: "/raise-ticket",
    TICKET_DETAILS:"/ticket-main-page",
    NOTFOUND: "/404NotFound",
    NOTIFICATION: "/notification",
    VIDEOTUTORIALS: "/videotutorials",
    APPLY_BRIEF: "/ApplyBrief",
    EDIT_BRIEF: "/EditBrief",
    PRODUCERPROFILE: "/producerProfile",
    COMPANYPROFILE: "/companyprofile",
    PROPOSALHALFSOLICATED: "/ProposalHalfSolicated",
    PROPOSALHALFUNSOLICATED: "/ProposalHalfUnSolicated",
    ACTIVATE_ACCOUNT: "/activate-account/:activationToken",
    ADD_CLUSTER: "/add-cluster",
    UPDATE_CLUSTER: "/update-cluster",
    CREATE_NEW_BRIEF: "/createnewbrief",
    EDIT_NEW_BRIEF: "/editnewbrief",
    HALFPAGE_BRIEF_DETAILS: "/half-page-brief-details",
    INTERNAL_HALFPAGE_BRIEFS: "/internal_half-page-briefs",
    SYS_ADMIN_COMP_APPROVE_REJECT: "/company-registration-approve-reject",
    SYS_ADMIN_PRODUCER_APPROVE_REJECT: "/producer-registration-approve-reject",
    REVIEW_PROPOSALS: "/review-proposals",
    SENIOR_MANAGER_EVALUATION_PAGE: "/senior_manager_evaluation_page",
    ADD_NEW_USER: "/add-new-user",
    UPDATE_NEW_USER: "/update-new-user",
  },
  IMG: {
    WATERMARK_IMAGE: "/images/mc_logo_watermark.svg",
    CAROUSAL_LOGO: "/images/mc_carousal_logo.svg",
    HELP_VIDEOS: "/images/help_videos.svg",
    ALL_CHANNELS_LOGO: "/images/channels_logo.svg",
    ERROR: "/images/Group.svg",
    LEFT_ARROW: "/images/left_arrow.svg",
    HIDE_PASSWORD: "/images/eye-off-line.svg",
    VIEW_PASSWORD: "/images/eye-on-line.svg",
    CLOSE: "/images/cross.svg",
    CHECK: "/images/check.svg",
    BLUE_CHECK: "/images/blue-check.svg",
    FILE_UPLOAD: "/images/upload.svg",
    DELETE: "/images/delete_Button.svg",
    FILE: "/images/file.svg",
    DELETE_FILE: "/images/delete_file.svg",
    DROPDOWN: "/images/down_arrow.svg",
    SUBMITTED: "/images/Submitted.svg",
    DRAFT: "/images/Draft.svg",
    INREVIEW: "/images/InReview.svg",
    REWORK: "/images/Rework.svg",
    INVITEDTOPITCH: "/images/InvitetoPitch.svg",
    ACCEPTED: "/images/Approved.svg",
    UNSUCCESSFUL: "/images/Unscuccessful.svg",
    SUBMITTED_SMALL: "/images/Submitted_small.svg",
    DRAFT_SMALL: "/images/Draft_small.svg",
    INREVIEW_SMALL: "/images/InReview_small.svg",
    REWORK_SMALL: "/images/Rework_small.svg",
    INVITEDTOPITCH_SMALL: "/images/InvitetoPitch_small.svg",
    ACCEPTED_SMALL: "/images/Approved.svg",
    UNSUCCESSFUL_SMALL: "/images/Unscuccessful_small.svg",
    INFO_BLUE: "/images/information-line-blue.svg",
    DROPDOWN: "/images/Dropdown.svg",
    DESC_ARROW_DISABLED: "/images/pagination-left-arrow-disabled.svg",
    DESC_ARROW: "/images/pagination-left-arrow.svg",
    INC_ARROW: "/images/right-arrow.svg",
    INC_ARROW_DISABLED: "/images/right-arrow-disabled.svg",
    SAMPLEIMG: "/images/sampleimg.jpg",
    SEARCH: "/images/searchIcon.svg",
    BACKGROUND_LOGO: "/images/Home/background_logo.svg",
    QUESTION_ICON: "/images/Home/question-line.svg",
    TICKETS_ICON: "/images/Home/Tickets.svg",
    BELL_ICON: "/images/Home/Group.svg",
    PROFILE_ICON: "/images/Home/user-line.svg",
    POPUP_QUESTION_ICON: "/images/FAQ/questionnaire-line.svg",
    FAQ_UP_ARROW: "/images/FAQ/arrow-up-s-line.svg",
    FAQ_DOWN_ARROW: "/images/FAQ/arrow-down-s-line.svg",
    SEARCH_ICON: "/images/FAQ/search-line.svg",
    CALENDER_ICON: "/images/calenderIcon.svg",
    VIEW_ICON: "/images/ViewIcon.svg",
    ARROW_DOWN_ICON: "/images/arrowdowndate.svg",
    ARROW_UP_ICON: "/images/arrow-up-line.svg",
    NOTIFICATION_ERROR_IMG: "/images/Illustration.svg",
    VIDEOTUTORIALS_ICON: "/images/movie-line.svg",
    PASSWORD_CRITERIA: "/images/password_criteria.svg",
    TOBEINVITED: "/images/tobeinvited.svg",
    TOBEASSIGNED: "/images/tobeassigned.svg",
    INVITETOVIRTUALPITCH: "/images/invitetovirtualpitch.svg",
    INVITETOMANAGEMENTTOPITCH: "/images/invitetomanagementpitch.svg",
    TOREVIEWEDORREWORK: "/images/InReview.svg",
    VIRTUALPITCH: "/images/invitetovirtualpitch.svg",
    MANAGEMENTTOPITCH: "/images/Approved.svg",
    INFO_ICON: "/images/information-line.svg",
    ARROW_UP: "/images/arrowup.svg",
    ARROW_DOWN: "/images/arrowdown.svg",
    LOGOUT: "/images/logout_new.svg",
    EDIT: "/images/Profile/edit.svg",
    PROFILE_BIG: "/images/Profile/profile_big.svg",
    DOWNLOAD: "/images/Profile/download.svg",
    LOGOUT: "/images/logout_new.svg",
    VIEW: "/images/view_Icon.svg",
    FILE: "/images/document_Icon.svg",
    HALF_PAGE_ERROR: "/images/HalfpageError.svg",
    REMOVE_FILE_ICON: "/images/RemoveFile.svg",
    DOCUMENT: "/images/document.svg",
    MANAGEMENTPITCH: "/images/managementpitch.svg",
    VIRTUALPITCH: "/images/virtualpitch.svg",
    ACTIVE: "/images/active.svg",
    SHELVED: "/images/shelved.svg",
    EXPIRED: "/images/expired.svg",
    GREENLIT: "/images/greenlit.svg",
    INREVIEW: "/images/InReview.svg",
    SUBMISSIONSCLOSED: "/images/active.svg",
    DASH: "/images/Home/dash.svg",
    LINE: "/images/Home/line.svg",
    REVIEWPENDING: "/images/InReview.svg",
    FILE_ICON: "/images/File_Icon.svg",
    DOWNLOAD_FILE: "/images/download.svg",
    CLUSTERS: "/images/clusters.svg",
    COMMISIONEREDITORS: "/images/commissioneditors.svg",
    CONTENTCOORDINATORS: "/images/contentcooridinators.svg",
    SENIORMANAGERS: "/images/seniormanagers.svg",
    RED_CLOSE: "/images/red_close.svg",
    INCEREVIEW: "/images/InReview.svg",
    INSMREVIEW: "/images/InReview.svg",
    INHOPREVIEW:"/images/InReview.svg",
    INVITETOMANAGEMENTPITCH: "/images/invitetoinmanagementpitch.svg",
    INVIRTUALPITCH: "/images/virtualpitch.svg",
    REVIEW_PENDING: "/images/InReview.svg",
    PROPOSALEDIT_ENABLED: "/images/editbtn_enabled.svg",
    PROPOSALEDIT_DISABLED: "/images/editbtn_disabled.svg",
    DOWNLOAD_ACTIVE: "/images/Download_Active.svg",
    DOWNLOAD_EXCEL: "/images/ExcelDownload.svg",
    LANG_SELECT: "/images/langselect.svg",
    STAR_SOLID: '/images/Home/fav_star.svg',
    STAR_UNSOLID: '/images/Home/favStarUnsolid.svg',
    MANAGEMENTPITCH: "/images/invitetomanagementpitch.svg",
    INMANAGEMENTPITCH: "/images/invitetomanagementpitch.svg",
    INVITETOMANAGEMENTTOPITCH:"/images/invitetomanagementpitch.svg",
    // DRAFT:'/images/shelved.svg',
  },
  ENDPOINT: {
    CAROUSAL: "/Carousel/GetAllCarousels",
    LOGIN: "/Authenticate/Login",
    EAMIL_EXIST: "/ProducerManagement/EmailExists/",
    ALL_LANGUAGES: "/common/Language/GetAllLanguage",
    ALL_GENRES: "/common/Genre/GetAllGenre",
    ALL_CHANNELS: "/common/Channel/GetAllChannel",
    ALL_REGIONS: "/common/Region/GetAllRegion",
    ALL_FORMATS: "/common/Format/GetAllFormat",
    ALL_CLUSTERS: "/common/Region/GetAllClusters",
    ALL_PRODUCTION_TYPES: "/common/Region/GetAllProductionType",
    ALL_TARGET_AUDIENCES: "/common/Region/GetAllTargetAudience",
    ALL_COUNTRIES: "/common/Country/GetAllCountry",
    PROVIENCE: "/common/Province/GetProvinceByCountryId?countryId=",
    FILTER_BY: "/common/Filters/FiltersByType",
    REGISTRATION: "/ProducerManagement/CreateProducer",
    MYPROPOSALS: "/Dashboard/ProposalOverview",
    BRIEFS: "/Brief/dashboard-briefs",
    ALL_LANGUAGES: "/common/Language/GetAllLanguage",
    ALL_GENRES: "/common/Genre/GetAllGenre",
    ALL_CHANNELS: "/common/Channel/GetAllChannel",
    FILTER_CHANNELS: "/common/Filters/GetAllFilters",
    PROPOSALS_COUNT: "/ProposalTypeCount/DashboardProposalCount",
    MY_PROPOSALS_DASHBOARD: "/ProposalTypeCount/dashboard-proposals",
    NOTIFICATION_API: "/Notification/GetLatestNotificationsByUserIdOrProducerId?",
    FAQ_PAGE_API: "/Faq/GetFaqByRoleId",
    NOTIFICATION_PAGE_DATA: "/Notification/GetNotificationsByUserIdOrProducerId?",
    VIDEOTUTORIALS: "/Video/GetAllVideosGroupedByCategory",
    UPDATENOTIFICATION: "/Notification/UpdateNotification",
    HALFPAGE_BRIEF: "/Brief/GetBriefMinDisplayByProposalId?proposalId=",
    CONTENTCOORDINATOR: "/Brief/AllDashboard-briefs",
    HALFPAGE_BRIEF_CLUSTERS: "/Common/Filters/FiltersByType",
    SOLICATED_PROPOSAL_HALFPAGE:
      "/Solicited/GetSolicitedMinDisplayProposalByIdWithLifeCycleAsync?producerId&proposalId=",
    UNSOLICATED_PROPOSAL_HALFPAGE:
      "/UnSolicited/GetUnSolicitedMinDisplayProposalByIdWithLifeCycleAsync?producerId&proposalId=",
    CHANNELS_BY_COUNTRY: "/common/Channel/GetChannelByCountryId/",
    SCRIPT_TYPES_BY_COUNTRY: "/common/ScriptType/GetScriptTypeByCountryId/",
    CLUSTER_BY_COUNTRY_AND_SCRIPT: "/common/Cluster/GetClustersByCountryAndScript/",
    LANGUAGES_BY_CHANNEL: "/common/Language/GetLanguagesByChannelId/",
    GENRES_BY_CLUSTER: "/common/Genre/GetGenresByClusterId/",
    CREATE_UNSOLICITED_PROPOSAL: "/UnSolicited/CreateUnSolicitedProposal",
    SOLICITED_EDIT_PROPOSAL: "/Solicited/GetSolicitedProposalById?producerId=",
    SOLICITED_SUBMIT_PROPOSAL: "Solicited/CreateSolicitedProposal",
    PRODUCER_DATA: "/ProducerManagement/GetProducerDetails",
    UPDATE_PRODUCER: "/ProducerManagement/UpdateProducer",
    GET_UNSOLICITED_PROPOSAL: "/UnSolicited/GetUnSolicitedProposalById",
    EDIT_UNSOLICITED_PROPOSAL: "/UnSolicited/UpdateUnSolicitedProposal",
    DELETE_UNSOLICITED_PROPOSAL: "/UnSolicited/DeleteUnSolicitedProposalByProposalId",
    SOLICITED_UPDATE_PROPOSAL: "/Solicited/UpdateSolicitedProposal",
    DELETE_SOLICITED_PROPOSAL: "/Solicited/DeleteSolicitedProposalByProposalId",
    VALIDATE_PRODUCER_MANDATORY_FIELDS: "/ProducerManagement/ValidateProducerField",
    USER_RECORDS_FROM_ACT_LINK: "/ProducerManagement/GetProducerDetailsByActivationKey/",
    ACTIVATE_ACCOUNT: "/ProducerManagement/ActivationOfUserAcount?producerId=",
    RESET_ACCOUNT: "Users/UpdateNewPassword?token=",
    RESET_ACCOUNT_FETCH: "Users/ResetRedirectPageDetails?token=",
    BRIEF_REACTIVE: "Brief/BriefReactive",
    BRIEF_SHELVE: "Brief/BriefShelve",
    BRIEF_SHELVE_STATUS: "Brief/GetBriefShelveStatus",
    SEND_RESET_LINK: "Users/ResetPassword?emailId=",
    FILTER_BY_PROPOSALSTATUS: "/ProposalTypeCount/GetProposalStatusesByRoleId",
    FETCH_ALL_PROPOSALS: "/ProposalTypeCount/CCDashboard-SolicitedProposals",
    FETCH_ALL_PROPOSALS_UNSOLICITED: "/ProposalTypeCount/CCDashboard-UnSolicitedProposals",
    FILTER_BY_PRODUCER: "/ProposalTypeCount/GetProposalAppliedProducersByClusterId",
    All_ROLES: "/Users/GetAllRoles?Roles=Internal",
    CREATE_USER: "/Users/CreateNewUser",
    UPDATE_USER: "/Users/UpdateUser?UserID=",
    DELETE_USER: "/Users/DeleteUser?UserID=",
    FILTER_BY_UNSOLICITED_STATUS: "/ProposalTypeCount/GetAllEvaluationStatus",
    //CC_UNSOLICITED_HALF_SCREEN:'/ProposalTypeCount/GetProposalMinDisplayByProposalId?',
    CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY:
      "/Solicited/GetSolicitedMinDisplayProposalByIdWithLifeCycleAsync?",
    FETCH_CHANNELS_BY_CLUSTER_ID: "/common/Channel/GetChannelsByClusterId/",
    FETCH_ALL_CLUSTERS: "/common/Cluster/GetAllClusters",
    FETCH_ALL_CHANNELS: "common/Channel/GetChannelsByClusterId/",
    RE_ASSIGN_BRIEF: "ProposalTypeCount/ProposalReAssignByProposalId",
    ALL_PROPOSAL_REJECTION_REASONS: "/ProposalTypeCount/GetAllProposalRejectReasons",
    UNSOLICITED_UPDATE_PROPOSAL: "/ProposalTypeCount/ProposalStatusUpdateByProposalId?roleId=",
    CLUSTER_BY_COUNTRY_AND_SCRIPT: "/common/Cluster/GetClustersByCountryAndScript/",
    LANGUAGES_BY_CHANNEL: "/common/Language/GetLanguagesByChannelId/",
    GENRES_BY_CLUSTER: "/common/Genre/GetGenresByClusterId/",
    CREATE_UNSOLICITED_PROPOSAL: "/UnSolicited/CreateUnSolicitedProposal",
    SOLICITED_EDIT_PROPOSAL: "/Solicited/GetSolicitedProposalById?producerId=",
    SOLICITED_SUBMIT_PROPOSAL: "Solicited/CreateSolicitedProposal",
    PRODUCER_DATA: "/ProducerManagement/GetProducerDetails",
    UPDATE_PRODUCER: "/ProducerManagement/UpdateProducer",
    GET_UNSOLICITED_PROPOSAL: "/UnSolicited/GetUnSolicitedProposalById",
    EDIT_UNSOLICITED_PROPOSAL: "/UnSolicited/UpdateUnSolicitedProposal",
    DELETE_UNSOLICITED_PROPOSAL: "/UnSolicited/DeleteUnSolicitedProposalByProposalId",
    SOLICITED_UPDATE_PROPOSAL: "/Solicited/UpdateSolicitedProposal",
    DELETE_SOLICITED_PROPOSAL: "/Solicited/DeleteSolicitedProposalByProposalId",
    VALIDATE_PRODUCER_MANDATORY_FIELDS: "/ProducerManagement/ValidateProducerField/",
    USER_RECORDS_FROM_ACT_LINK: "/ProducerManagement/GetProducerDetailsByActivationKey/",
    ACTIVATE_ACCOUNT: "/ProducerManagement/ActivationOfUserAcount?producerId=",
    FILTER_BY_CREATEDBY: "/Users/GetUserListsByRoleIdsAndClusterId",
    FILTER_BY_REPORTINGTO: "/Users/GetUserListsByRoleIdsAndClusterIds",
    FILTER_BY_PROPOSALSTATUS: "/ProposalTypeCount/GetAllBriefStatus",
    FETCH_ALL_PROPOSALS: "/ProposalTypeCount/CCDashboard-SolicitedProposals",
    FETCH_ALL_PROPOSALS_UNSOLICITED: "/ProposalTypeCount/CCDashboard-UnSolicitedProposals",
    FILTER_BY_PRODUCER: "/ProposalTypeCount/GetProposalAppliedProducersByClusterId",
    FILTER_BY_UNSOLICITED_STATUS: "/ProposalTypeCount/GetProposalStatusesByRoleId?roleId=",
    CC_UNSOLICITED_HALF_SCREEN:
      "/UnSolicited/GetUnSolicitedMinDisplayProposalByIdWithLifeCycleAsync?",
    CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY:
      "/Solicited/GetSolicitedMinDisplayProposalByIdWithLifeCycleAsync?",
    FETCH_ALL_CE_SOLICITED_PROPOSALS: "/ProposalTypeCount/CEDashboard-SolicitedProposals",
    FETCH_ALL_CE_UNSOLICITED_PROPOSALS: "/ProposalTypeCount/CEDashboard-UnSolicitedProposals",
    CE_UNSOLICITED_HALF_SCREEN:
      "/UnSolicited/GetUnSolicitedMinDisplayProposalByIdWithLifeCycleAsync?",
    ALL_PROPOSAL_REJECTION_REASONS: "/ProposalTypeCount/GetAllProposalRejectReasons",
    LOGOUT: "/Authenticate/Logout",
    //FILE_DOWNLOAD:"/FileUpload/presignedurl?fileName=Proposals/",
    SYS_ADMIN_APPROVE_REJECT_REG: "/ProducerManagement/ApproveProducerAccount?",
    PROPOSAL_FILE_DOWNLOAD: "/FileUpload/presignedurl?fileName=Proposals/",
    FETCH_SM_SOLICITED_PROPOSALS: "/ProposalTypeCount/SMDashboard-SolicitedProposals",
    FETCH_SM_UNSOLICITED_PROPOSALS: "/ProposalTypeCount/SMDashboard-UnSolicitedProposals",
    UNSOLICITED_ASSIGN_PROPOSAL: "/Users/GetUserListsByRoleIdsAndClusterId?",
    EVALUATION_CRITERIA: "/common/Criteria/GetAllCriteria",
    PRODUCER_FILE_DOWNLOAD: "/FileUpload/download?fileName=",
    //FILE_DOWNLOAD:"/FileUpload/presignedurl?fileName=Proposals/",
    FILE_DOWNLOAD: "/FileUpload/download?fileName=Proposals/",
    ASSIGN_PROPOSAL_POST: "/ProposalTypeCount/AssignProposal?roleId=",
    REJECT_PROPOSAL_POST: "/ProposalTypeCount/RejectProposal?roleId=",
    FETCH_COMPANIES: "/InternalManagementForSysAdmin/GetCompanyDetails",
    FETCH_INDIVIDUALS: "/InternalManagementForSysAdmin/GetIndividualDetails",
    SM_EVALUATION_POST: "/ProposalTypeCount/ProposalStatusUpdateByProposalId",
    GET_PRODUCER_DETAILS_BYID: "/ProducerManagement/GetProducerDetailsByProducerId?producerId=",
    SM_EVALUATION_POST: "/ProposalTypeCount/ProposalStatusUpdateByProposalId",
    UNSOLICITED_REVIEW_PROPOSAL: "/ProposalTypeCount/ProposalReviewByProposalId",
    UNSOLICITED_CRITERIA_VALUE: "/ProposalTypeCount/GetProposalCriteriaByProposalId?proposalId=",
    SM_EVALUATION_POST: "/ProposalTypeCount/ProposalStatusUpdateByProposalId",
    UNSOLICITED_REVIEW_PROPOSAL: "/ProposalTypeCount/ProposalReviewByProposalId",
    // Requests endpoint
    GET_BRIEF_REQUESTS: '/Requests/GetBriefRequests',
    GET_PROPOSAL_REQUESTS: '/Requests/GetProposalRequests',
    GET_BRIEF_SHELVE_REQUESTS: '/Requests/GetBriefShelveRequests',
    GET_USER_APPROVAL_REQUESTS: '/Requests/GetUserApprovalRequests',
    BRIEF_STATUS_UPDATE: '/Requests/BriefStatusUpdate',
    PROPOSAL_STATUS_UPDATE: 'Requests/ProposalStatusUpdate',
    BRIEF_SHELVE_STATUS_UPDATE: 'Requests/BriefShelveStatusUpdate',
    USER_APPROVAL_STATUS_UPDATE: 'Requests/UserApprovalStatusUpdate',
    GET_BRIEF_REQUEST_BY_PROPOSALID: 'Requests/GetBriefRequestsByProposalId?ProposalId=',
    SM_EVALUATION_LIST: "/ProposalTypeCount/GetProposalSMEvaluationByProposalId?",
    FETCH_COMPANIES: '/InternalManagementForSysAdmin/GetCompanyDetails',
    FETCH_INDIVIDUALS: '/InternalManagementForSysAdmin/GetIndividualDetails',
    SM_EVALUATION_POST: "/ProposalTypeCount/ProposalStatusUpdateByProposalId",
    FETCH_CLUSTERSINFO: "/InternalManagementForSysAdmin/ClusterManagement",
    FETCH_USERSINFO: "/InternalManagementForSysAdmin/GetAllUserDetails",
    SM_EVALUATION_POST: "/ProposalTypeCount/ProposalStatusUpdateByProposalId",
    CREATE_CLUSTER: "/common/Cluster/CreateCluster",
    UPDATE_CLUSTER: "/common/Cluster/UpdateCluster?clusterId=",
    DELETE_CLUSTER: "/common/Cluster/DeleteCluster?clusterId=",
    FETCH_ALL_SCRIPTTYPES: "/common/ScriptType/GetAllScriptTypes",
    USER_EMAIL_EXISTS: "/Users/EmailExists/",
    PRODUCTION_TYPE: "/common/ProductionType/GetAllProductionType",
    FETCH_CHANNEL_BY_CLUSTER: "/common/Channel/GetChannelsByClusterId/",
    UPDATE_PROPOSALTITLE: "/ProposalTypeCount/UpdateProposalTitle?",
    DOWNLOADUNSOLICITEDPDF: "/UnSolicited/GetUnSolicitedExportToPDFAsync?",
    DOWNLOADUNSOLICITEDWORD: '/UnSolicited/GetUnSolicitedExportToWordAsync?',
    DOWNLOADSOLICITEDPDF: "/Solicited/GetSolicitedExportToPDFAsync?",
    DOWNLOADSOLICITEDWORD: '/Solicited/GetSolicitedExportToWordAsync?',
    DOWNLOADBRIEFPDF: '/Brief/GetBriefExportToPDFAsync?',
    DOWNLOADBRIEFWORD: '/Brief/GetBriefExportToWordAsync?',
    AUDITTRAILPROPOSALS: '/AuditTrail/GetAuditTrailProposals?',
    AUDITTRAILBRIEFS: '/AuditTrail/GetAuditTrailBrief?',
    PRODUCERBYCLUSTERBYTYPE: '/ProposalTypeCount/GetAppliedProducersByClusterIdAndProposalType',
    SETCONSENT: '/ProducerManagement/SetConsent',
    BRIEFEXCELDOWNLOAD: '/Brief/GetBriefAppendixHExportAsync?',
    FILTERACTIONBY: '/Users/GetUsersByRoleIdAndClusterId?',
    EXPORTAUDITTRAILPROPOSALS: '/AuditTrail/ExportAuditTrailProposals?roleId=',
    EXPORTAUDITTRAILBRIEFS: '/AuditTrail/ExportAuditTrailBrief?roleId=',
    UPDATE_CE_EVAL_LIST: "/ProposalTypeCount/UpdateEvaluationUserList?roleId=",
    UPDATE_FAVOURITE:"/ProposalTypeCount/UpdateFavourite?isFavourite=",
    FETCH_PROPOSALS_BY_PRODUCER_ID:'/Ticket/GetAllProposalOrBriefNoAndTitle?ticketType=',
    CREATE_TICKET: '/Ticket/CreateTicket',
    PRODUCER_TICKETS: "/Ticket/GetProducerTickets",
    TICKETDETAILS_TICKETID: "/Ticket/GetTicketCardDetailsByTicketId?ticketId=",
    CC_TICKETS: "/Ticket/GetAllTicketsByClusterForCC",
    UPDATE_TICKET_STATUS: "/Ticket/UpdateTicketStatus?ticketId=",
    CE_TICKETS: "/Ticket/GetAllTicketsForCE",
    SA_TICKETS: "/Ticket/GetAllOtherTickets",
    CE_DRAFTED_EVAL_SCORES:"/ProposalTypeCount/GetProposalCriteriaAndGradeListByProposalId",
    SM_DRAFTED_EVAL_SCORES:"/ProposalTypeCount/GetSMDetailsByProposalId",
  },
  ERROR_MESSAGES: {
    NO_CAROUSAL_DATA_ERROR: "Something went wrong... please try after sometime",
    GENERIC_API_ERROR: "Error occured in API call",
    EMAIL_ERROR: "Incorrect username or password",
    PASSWORD_ERROR: "Incorrect Password. Please check and re-enter password",
    NW_ERROR: "ERR_NETWORK",
    EMPTY_EMAIL: "Please fillout this field",
    EMPTY_PASSWORD: "Please fillout this field",
    INVALID_EMAIL_FORMAT: "Please enter valid email",
    INVALID_PASSWORD_FORMAT: "Please enter valid password",
    EMAIL_EXIST: "Email already exists",
    EMAIL_NOT_EXIST: "Email does not exist",
    INVALID_PHONE_NUMBER: "Invalid phone number",
    INVALID_NAME: "Invalid name",
    INVALID_COMPANY_REG_NO: "Please enter valid company registration no.",
    INVALID_WEBSITE: "Invalid website",
    INVALID_SOCIAL_MEDIA_LINKS: "Invalid social media link",
    INVALID_VAT_REG_NUM: "Please enter valid VAT registration no.",
    INVALID_VEN_REG_NUM: "Please enter valid vendor registration no.",
    EMPTY_NAME: "Please enter name",
    EMPTY_PHONE_NUMBER: "Please enter phone number",
    REG_EMPTY_EMAIL: "Please enter email",
    REG_INVALID_EMAIL: "Invalid email",
    EMPTY_COMPANY_NAME: "Please enter company name",
    EMPTY_COMPANY_REG_NO: "Please enter company registration no.",
    EMPTY_KEY_CONTACT_NAME: "Please enter key contact name",
    EMPTY_KEY_CONTACT_EMAIL: "Please enter key contact email",
    EMPTY_WEBSITE: "Please enter website",
    EMPTY_SOCIAL_MEDIA_LINK: "Please enter social media link",
    EMPTY_COMPANY_CONTACT_NUMBER: "Please enter company contact no.",
    EMPTY_COMPANY_CONTACT_EMAIL: "Please enter company contact email",
    EMPTY_COMPANY_VENDOR_REG_NUM: "Please enter vendor registration no.",
    UNSELECTED_TITLE: "Please select title",
    COMPANY_NAME_EXISTS: "Company name already exists",
    COMPANY_REG_NUM_EXISTS: "Company registration no. already exists",
    VAT_REG_NUM_EXISTS: "VAT registration no. already exists",
    VENDOR_REG_NUM_EXISTS: "Vendor registration no. already exists",
    ACTIVATION_PAGE_PASSWORD_ERROR: "The entered password does not meet the criteria",
    RESET_PAGE_PASSWORD_ERROR: "The entered password does not meet the criteria",
    ACTIVATION_PAGE_PASSWORD_MISMATCH: "Passwords do not match. Please re-enter your password. ",
    RESET_PAGE_PASSWORD_MISMATCH: "Passwords do not match. Please re-enter your password. ",
    ACTIVATE_RE_ENTER_PASSWORD_EMPTY: "Please re-enter the password",
    RESET_RE_ENTER_PASSWORD_EMPTY: "Please re-enter the password",
    ACTIVATE_PASSWORD_EMPTY: "Please enter the password",
    RESET_PASSWORD_EMPTY: "Please enter the password",
    EMPTY_EMAIL_CONTENT: "Please enter the email content",
    EMPTY_REASON_DD: "Please select reasons for rejection",
    CLUSTER_APPROVAL_SCORE: "Please enter a number from 0 to 10",
    EMPTY_COUNTRY: "Please select country",
    EMPTY_SCRIPT_TYPE: "Please select scripted/non-scripted",
    EMPTY_GENRE: "Please select genre",
    EMPTY_CLUSTER_NAME: "Please select country and scripted/non-scripted",
    DESIGNATION: "Please select designation",
    ERROR_CLUSTER: "Please select cluster",
    ERROR_REPORTINGTO: "Please select reporting manager",
    EMPTY_LOCATION: "Please enter location",
    EMPTY_TAX_FILE: "Please select tax clearance document",
    EMPTY_BBEE_FILE: "Please select BBBEE compliant document",
    INVALID_DURATION: "Please enter a valid duration",
    INVALID_NO_OF_EPISODES: "Please enter a number above 7",
    INVALID_EPISODE_DURATION: "Please enter a valid episode duration",
    INVALID_TOTAL_DURATION: "Please enter total duration",
    INVALID_NO_OF_MINI_EPISODES: "Please enter a number from 1 to 7",
    INVALID_EPISODE_MIN_DURATION: "Please enter a valid episode duration",
    INVALID_TOTAL_MINI_DURATION: "Please enter total duration"
  },
  APP_TITLE: "Submission Portal",
  HELP_VIDEOS: "Video Tutorials", //"Help Videos",
  MANDATORY_FIELD: "*",
  LOGIN: {
    TITLE: "Get Started",
    RESET_PASSWORD: "Reset Password",
    RESET_LINK_EMAIL: "Send Reset Link via Email",
    EMAIL: "Email ",
    EMAIL_PLACEHOLDER: "Eg. johndoe@company.com",
    PASSWORD: "Password ",
    PASSWORD_PLACEHOLDER: "Enter password",
    FORGOT_PASSWORD: "Forgot Password",
    LOGIN: "Login",
    UPDATE: "Update",
    ACCOUNT_QUESTION: "Don’t have an account?",
    REGISTER: " Register",
    NOW: " now!",
    MIN_PASSWORD_LENGTH: 6,
    MAX_PASSWORD_LENGTH: 20,
  },
  REGEX: {
    EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
    ACTIVATION_PASSWORD_REGEX:
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+~`|}{[\]:;<>,.?\/\\-])(?=.*\S)[a-zA-Z0-9!@#$%^&*()_+~`|}{[\]:;<>,.?\/\\-]{8,20}$/,
    PHONE_NUMBER_REGEX: /^[+]?\d{7,15}$/,
    NAME_REGEX: /^[a-zA-Z0-9\s'!@#$%^&*(),.?":{}|<>-]+$/,
    WEBSITE_REGEX: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{1,6}(\/[a-zA-Z0-9#]+\/?)*$/,
    SOCIAL_MEDIA_LINKS_REGEX:
      /^(https?:\/\/)?(www\.|m\.|in\.)?([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]{1,6})(\/[a-zA-Z0-9_./-]+)?[a-zA-Z0-9]$/,
    //SOCIAL_MEDIA_LINKS_REGEX: /^(https?:\/\/)?(www\.|m\.|in\.)?(facebook|twitter|instagram|linkedin|youtube|tiktok|snapchat|reddit|x|pinterest|snapchat|douyin|telegram|quora|tumblr)\.([a-z.]{1,6})(\/[a-zA-Z0-9_./-]+)?[a-zA-Z0-9]$/,
    //PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/,

    PH_NUMBER_REGEX: /^[0-9+]*$/,
    NUMBER_REGEX: /^[0-9]*$/,
  },
  TEST: {
    SAMPLE_YOUTUBE_LINK: "https://www.youtube.com/watch?v=6JYIGclVQdw",
  },
  COLORS: {
    ACTIVE_BUTTON: "",
    DISABLED_BUTTON_BG: "#737374",
    DISABLED_BUTTON_TXT_COLOR: "#B8B9BA",
  },
  SIGNUP: {
    VENDOR_REG_FILE_UPLOAD_CONTROLS: {
      VAT_CLEARANCE_CERTIFICATE: "Valid Tax Clearance Certificate",
      VAT_103: "VAT 103 ( If no VAT No. in TCC )",
      TAX_INVOICE: "Tax invoice / sample invoice",
      REG_DOCS: `Registration documents if applicable /\n A certified copy of ID.`,
      VALID_BBEEE_CERTIFICATE: "Valid B-BBEE Compliance Certificate /\n EME Affidavit",
      BANK_STAMPED: "Bank stamped letter not older than 3 months /\n Cancelled cheque",
    },
    TYPE: {
      INDIVIDUAL: "Individual",
      COMPANY: "Company",
    },
    CONFIDENTIALITY_AGREEMENT: "Confidentiality Agreement",
    CONFIDENTIAL_INFO:
      "By using this portal, it is understood and agreed that this portal contains confidential information which may not be shared with any third party and may not appear in the public domain without the prior written consent of MultiChoice.",
    EDIT_PRODUCER: "Edit Individual Producer Profile",
    EDIT_COMPANY: "Edit Company Profile",
    EXERCISE_YOUR_RIGHTS: " Exercise your Rights",
    COMPANY: "Register as a Company",
    COMPANY_DESC_LINE1:
      "A company refers to a legally registered entity that operates as a collective organization. It may be a corporation, partnership, or other formal legal entity.",
    COMPANY_DESC_LINE2:
      "Proposals must be submitted on behalf of the business entity and include the company’s legal name, registration details, and designated contact management.",
    INDIVIDUAL: "Register as an Individual",
    INDIVIDUAL_DESC_LINE1:
      "An individual refers to a single management submitting a proposal in their Personal capacity, not affiliated with or representing a legally registered company.",
    INDIVIDUAL_DESC_LINE2:
      "Examples include independent creators, freelancers, or aspiring producers without formal business registration.",
    BASIC_INFO: "Basic Information",
    COMPANY_INFO: "Company Information",
    COMPANY_NAME_LABEL: "Company Name",
    COMPANY_REG_NUMBER_LABEL: "Company Registration No.",
    COMPANY_LOGO_LABEL: "Company Logo",
    KEY_CONTACT_NAME_LABEL: "Key Contact Name",
    KEY_CONTACT_MAIL_LABEL: "Key Contact Email",
    FORMAT_LABEL: "Format",
    PRODUCTION_TYPE_LABEL: "Production Type",
    SATUTORY_INFO_LABEL: "Statutory Information",
    VAT_REG_NUM_LABEL: "VAT Registration No.",
    VEN_REG_NUM_LABEL: "Vendor Registration No.",
    TAX_CERTIFICATE_QUESTION_LABEL: "Do you have a valid tax clearance certificate/pin?",
    BBEE_COMPLIANT_LABEL: "Are you B-BBEE Compliant?",
    VENDOR_REQUIRED: "Are you vendor registered?",
    YES: "Yes",
    NO: "No",
    PLEASE_UPLOAD: "If yes, please upload",
    CONTACT_INFO_LABEL: "Contact Information",
    COMPANY_CONTACT_NUM_LABEL: "Company Contact No.",
    COMPANY_EMAIL_LABEL: "Company Email",
    COMPANY_ADDRESS: "Company Address",
    TITLE: "Title",
    NAME: "Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Phone Number",
    LOGO_PIC: "Logo/Picture",
    PHYSICAL_ADDRESS: "Physical Address",
    PROVIENCE: "County/Province/Region",
    COUNTRY: "Country",
    WEBSITE: "Website",
    SOCIAL_MEDIA: "Social Media",
    LANGUAGE: "Language",
    GENRE: "Genre",
    CHANNELS: "Channels Worked on",
    DECLRATION_INFO: "Declaration of Information",
    DECLARATION_STMT1: "I hereby declare that the information provided is true and correct.", //"I hereby declare that the information provided is true and correct.​",
    DECLARATION_STMT2:
      "I understand that any misrepresentations or incorrect information may result in my submission being disqualified.",
    //"I understand that any misrepresentations or incorrect information may result in applications applied for, or membership on this website, being considered invalid",
    READ_AGREE: "I am submitting this information in accordance with the ", //"I have read and agree to the ",
    COMMISSIONG_PROTOCOL: "Commissioning Protocol",
    I_ACCEPT1:
      "By registering for an account, I consent to the processing of my Personal information for the purposes of participating in the entertainment content proposal",
    I_ACCEPT_1_1:
      "process. For more details on how we process your Personal information, please refer to our",
    I_ACCEPT2:
      "As a user, you have rights regarding the Personal information we collect. These include the right to access, correct, or delete your Personal information, as",
    I_ACCEPT2_2:
      "well as the right to object to or restrict processing. To learn more about how to exercise your data subject rights, please visit",
    PRIVACY_POLICY: " Privacy Policy",
    PRIVACY_NOTICE: " Privacy Notice",
    TITLES_LIST: ["Mr", "Mrs", "Ms", "Miss", "Mx", "Dr"],
    TITLES_INP_PLACEHOLDER: "Eg. Mr/Ms",
    NAME_INP_PLACEHOLDER: "Eg. John Doe",
    EMAIL_INP_PLACEHOLDER: "Eg. johndoe@abc.com",
    PHONE_NUMBER_INP_PLACEHOLDER: "Eg. +225 01 93 94 17 43",
    UPLOAD: "Upload",
    UPLOAD_FILE_PLACEHOLDER: "or Drop files here",
    ADDRESS_PLACEHOLDER: "Eg. 123, 6th Park avenue, Rose street, Durban, SA ",
    PROVIENCE_PLACEHOLDER: "Please select country first",
    COUNTRY_PLACEHOLDER: "Please select country",
    WEBSITE_PLACEHOLDER: "Eg. www.abc.com",
    SOCIAL_MEDIA_PLACEHOLDER: "Eg. instagram.com/abccompany",
    ADD_MORE_LINKS: "+ Add more links",
    LANGUAGE_PLACEHOLDER: "Please select channel first",
    GENRE_PLACEHOLDER: "Select genre",
    CHANNELS_PLACEHOLDER: "Select channels",
    COMPANY_PLACEHOLDERS: {
      COMPANY_NAME: "Eg. ABC company",
      COMPANY_REG_NUMBER: "Eg. Registration number",
      KEY_CONTACT_NAME: "Eg. John Doe",
      KEY_CONTACT_MAIL: "Eg. johndoe@abc.com",
      FORMAT: "Select format",
      PRODUCTION_TYPE: "Select type",
      VAT_REG_NUM: "Eg. Registration number",
      VEN_REG_NUM: "Eg. Registration number",
      COMPANY_CONTACT_NUM: "Eg. +27 903 033431",
      COMPANY_EMAIL: "Eg. business@abc.com",
    },
    POPUP: {
      SUCCESS: {
        TITLE: "Thank you for your Registration",
        L1_MESSAGE: "Your account has been successfully registered!",
        L2_MESSAGE:
          "General Entertainment will review your registration and initiate an activation link to the email address provided. You can use the link to login to the submission portal.",
        BUTTON_TEXT: "Return to Homepage",
      },
      FAILURE: {
        TITLE: "Registration Failed",
        MESSAGE:
          "There was an error with your registration. Please enter your details and try again. We’re sorry for the inconvenience.",
        BUTTON_TEXT: "Retry",
      },
      CANCEL: {
        TITLE: "Abort Registration",
        MESSAGE:
          "Are you sure you would like to abort the process of registration? All the data entered so far will be lost.",
        BUTTON_TEXT: "Abort Registration",
      },
      CONFIRM_BTN_TXT: "Confirm",
    },
  },
  FILES: {
    COMMISSIONNING_PROTOCOL: "/files/Commissioning_protocol _26_October_2020_final.pdf",
  },
  FILE_UPLOADER: {
    UPLOAD: "Upload",
    DROP_FILES: "or Drop files here | Max File Size: 500MB",
  },
  DASHBOARD: {
    ALL: "All",
    SOLICITED: "Solicited",
    UNSOLICITED: "Unsolicited",
    ONEMONTH: "1 month",
    SIXMONTHS: "6 months",
    ONEYEAR: "1 year",
    GREATERTHANONEYEAR: "> 1 year",
    OPEN: "Open",
    CLOSED: "Closed",
    RESULTS: "",
    UNREAD: "Unread",
    READ: "Read",
  },
  MYPROPOSALS: {
    RESULTS: "Proposals",
  },
  SOLICITED_PROPOSAL: {
    PROPOSALId: "Proposal Id",
    PROPOSAL_TIMELINE: "Proposal Timeline",
    PROPOSAL_COMPANY: "ABC Company ",
    PROPOSAL_TITLE: "Pitch Perfect",
    COMMENTS: "Comments",
    DETAILS: "Proposal Details",
    LOGLINE: "Logline",
    SYNOPSIS: "Synopsis",
    EPISODE: "Episode Structure and Outline",
    EDITORIAL: "Editorial Details",
    CURRENCY: "currency",
    PRELIMINARY: "Preliminary Budget",
    PRODUCTION: "Pitch Deck",
    LOCATION: "Location and Studio Information",
    CAST: "Cast and Presenter Information",
    BRAND: "Brand Integration Opportunites",
    COMPANY: "Company Profile and Team Details",
    REEL: "Showreel of Previous Content Or Show",

    DOCUMENTS: {
      LBMB: "Lookbook and Moodboard",
      CPRC: "Certificate of Copyright/Registration for Originals Content",
      RDOC: "Regulatory Documentation",
      PRSCH: "Pitch Deck",
      SHWRL: "Showreel of Previous Content or Shows",
      VP: "Video Presentation",
      SCRIPT: "Script Final Draft",
      FINANCIAL: "Budget Breakdown",
      VISUALS: "Concept Art",
      CASTING: "Casting List",
      TKTDOC: "Ticket Document"    },
  },
  UNSOLICITED_PROPOSAL_HALF: {
    BREFNO: "BRefNo",
    PROPOSAL_TITLE: "Proposal Title",
    DESCRIPTION: "Description",
    REQUIREMENTS: "SubmissionRequirements",
    EVALANDSELECTION: "EvalAndSelection",
    FORMAT: "Format",
    DETAILS: "Proposal Details",
    LANGUAGE: "Language",
    COUNTRY: "Country",
    CHANNEL: "Channel",
    CONTENT: "Content",
    GENRE: "Genre",
    OTHERGENRE: "Other Genre",
    CLUSTER: "Cluster",
    PRODUCTIONTYPE: "Production Type",
    CLOSING_DATE: "ClosingDate",
    BRIEFSTATUS: "BriefStatus",
    LOGLINE: "Logline",
    NOOFEPISODES: "No. of Episodes",
    EPISODE_DURATION: "Episode Duration",
    LOCATION_STUDIO_INFO: "Location and Studio information",
    VIDEO_PRESENTATION: "Video Presentation",
    PRODUCTIONTIMELINE: "Production TimeLine",
    ARTIST_NAME: "Artist Name",
    SONG_NAME: "Song Name",
    EPISODE_OUTLINE: "Episode Structure & Outline",
    LOCATION: "Locations and Studio Information",
    CAST_PRESENTER_INFO: "Cast and Presenter Information",
    BRAND_INTEGRATION_OPPORTUNITIES: "Brand Integration Opportunities",
    PROJECT_STATUS: "Projects Status ",
    KEY_TEAM: "Key Team",
    REFERENCE_LINKS: "Reference Links",
    ADD_MORE: "Add more links(total 3)",
    SUBMISSION_DATE: "SubmissionDate",
    SCRIPTED: "Scripted / \n Non-Scripted",
    TARGET_AUDIENCE: "Target Audience",
    EPISODE_STRUCTURE: "Episode Structure and Outline",
    SYNOPSIS: "Synopsis",
    COMMENTS: "cOMMENTS",
    DURATIONINMINS: "Duration(in mins)",
    EPDURATION: "Episode Duration (in mins)",
    TOTALEPDURATION: "Total Duration (in mins)",
    CURRENCY: "Currency",
    TARGET_BUDGET: "Target Budget",
    DOCUMENTS: {
      LOOKBOOK: "Lookbook and Moodboard",
      PRODUCTION: "Pitch Deck",
      SHOWREEL: "Showreel of Previous Content or Shows",
      CERTIFICATE: "Certificate of Copyright/Registration for Originals Content",
      REGULATORY: "Regulatory Documentation",
      SCRIPT: "Script Final Draft",
      FINANCIAL: "Budget Breakdown",
      VISUALS: "Concept Art",
      CASTING: "Casting List",
    },
  },
  UNSOLICITED_PROPOSAL: {
    CREATE_UNSOLICITED_PROPOSAL_TITLE: "Create an Unsolicited Proposal",
    PROPOSAL_TITLE: "Proposal Title",
    PROPOSAL_DETAILS: "Proposal Details",
    PRODUCTION_TYPE: "Production Type",
    CHANNEL: "Channel",
    COUNTRY: "Country",
    REGION: "Region",
    SCRIPTED_UNSCRIPTED: "Scripted/Non-scripted",
    SCRIPTED_UNSCRIPTED_LIST: ["Scripted", "Unscripted"],
    GENRE: "Genre",
    CLUSTER: "Cluster",
    LANGUAGE: "Language",
    TARGET_AUDIENCE: "Target Audience",
    FORMAT: "Format",
    DURATION: "Duration (in mins)",
    NO_OF_EPISODES: "No. of Episodes",
    EPISODE_DURATION: "Episode Duration (in mins)",
    SYNOPSIS: "Synopsis",
    LOGLINE: "Logline",
    TARGET_BUDGET: "Target Budget",
    PRODUCTION_SCHEDULE: "Pitch Deck ( .pdf or .doc or .ppt )",
    PITCH_DECK: "Pitch Deck",
    EPISODE_STRUCTURE_OUTLINE: "Episode Structure and Outline",
    LOCATION_STUDIO_INFO: "Location and Studio Information",
    CAST_PRESENTER_INFO: "Cast and Presenter Information",
    BRAND_INTEGRATION_OPPORTUNITIES: "Brand Integration Opportunities",
    PROJECT_STATUS: "Project Status",
    KEY_TEAM: "Key Team",
    ARTIST_NAME: "Artist Name",
    SONG_NAME: "Song Name",
    VIDEO_PRESENTATION: "Video Presentation ( .mp4 )",
    REFERENCE_LINKS: "Reference Links",
    MEDIA: "Media",
    MINI_SERIES: "Mini-Series (Less than 8 Episodes)",
    BIG_SERIES: "Series (8+ Episodes)",
    BIG_SERIES_MORE: "Series (8 or More Episodes)",
    NO_OF_EPISODE_INPUT: "no-of-episodes-input",
    EPISODE_DURATION_INPUT: "episode-duration-input",
    TARGET_BUDGET_INPUT: "target-budget-input",
    DURATION_INPUT: "duration-input",
    NOTE: "NOTE: Producers are encouraged to provide an entertaining deck demonstrating series creative approach.",
    CURRENCY: "Currency",
    PLACEHOLDERS: {
      PROPOSAL_TITLE: "Eg. Breaking Bad",
      PRODUCTION_TYPE: "Eg. Co-Production",
      CHANNEL: "Eg. M-Net Movies",
      REGION: "Eg. Cote d'Ivoire",
      SCRIPTED_UNSCRIPTED: "Eg. Scripted",
      CURRENCY: "Eg. ZAR",
      GENRE: "Please select country & script type",
      CLUSTER: "SA Premium Scripted",
      LANGUAGE: "Eg. Kids/Adult",
      TARGET_AUDIENCE: "Eg. Kids/Adult",
      FORMAT: "Eg. Movie",
      DURATION: "Eg. 130",
      NO_OF_EPISODES: "Eg. 10",
      EPISODE_DURATION: "Eg. 20",
      SYNOPSIS: "Eg. In a galaxy far, far away",
      LOGLINE: "Eg. In a galaxy far, far away",
      TARGET_BUDGET: "Eg. 100,000",
      PRODUCTION_SCHEDULE: "Eg. Description regarding Shoot details",
      EPISODE_STRUCTURE_AND_OUTLINE: "Eg. 2 Seasons, 15 episodes",
      LOCATION_AND_STUDIO_INFORMATION: "Eg. Cities, Locations and Addresses",
      CAST_AND_PRESENTER_INFORMATION: "Eg. Brad Pitt etc.",
      BRAND_INTEGRATION_OPPORTUNITIES: "Eg. Adidas, Pepsi, Gucci",
      PROJECT_STATUS: "Eg. Post Production",
      KEY_TEAM: "Eg. Director, D.O.P etc.",
      ARTIST_NAME: "Eg. Drake",
      SONG_NAME: "Eg. Hotline Bling",
      VIDEO_PRESENTATION: "Upload or Drop files here",
      REFERENCE_LINKS: "Eg. youtube.com/abccompany",
    },
  },
  FILTER: {
    CHANNEL: "Channel",
    COUNTRY: "Country",
    TYPE: "Type",
    FORMAT: "Format",
    GENRE: "Genre",
    LANGUAGE: "Language",
    BUDGET: "Budget",
    STATUS: "Status",
    DATE: "Date",
    CREATEDBY: "Created By",
    CLOSINGDATE: "Closing Date",
    EXPIRYDATE: "Expiry Date",
    GENRE: "Genre",
    REGDATE: "Registration Date",
    PRODUCER: "Producer",
    APPLICATIONDATE: "Application Date",
    REQUESTEDBY: "Requested by",
  },
  FILTER_OPTIONS_NAME: {
    CHANNEL: "Channels",
    COUNTRY: "Countries",
    TYPE: "ProductionTypes",
    FORMAT: "Formats",
    GENRE: "Genres",
    LANGUAGE: "Languages",
    BUDGET: "Budget",
    STATUS: "Status",
    DATE: "Date",
    CLUSTERS: "Clusters",
    OTHER_TICKET_CATEGORIES: "OtherTicketCategories",
  },
  FILTER_OPTIONS_NAME_MYPROPOSALS: {
    CHANNEL: "Channels",
    TYPE: "ProposalTypes",
    STATUS: "Status",
  },
  SUMMARY_CARD_NAME: {
    submitted: "Submitted",
    draft: "Draft",
    inReview: "In Review",
    rework: "Re-work",
    invitedToPitch: "Invite to Pitch",
    accepted: "Accepted",
    unsuccessful: "Unsuccessful",
    toBeInvited: "To be Invited",
    toBeAssigned: "To be assigned",
    inviteToVirtualPitch: "Invite to Virtual Pitch",
    inviteToInManagementToPitch: "Invite to Management Pitch",
    toReviewedOrReWork: "In Review / Re-work",
    inManagementPitch: "In Management Pitch",
    virtualPitch: "Virtual Pitch",
    accepted: "Accepted",
    inVirtualPitch: "Virtual Pitch",
    reviewPending: "Review Pending",
    clusters: "Clusters",
    contentCoordinators: "Content Coordinators",
    commisionerEditors: "Commissioning Editors",
    seniorManagers: "Senior Managers",
    managementPitch:"In Management Pitch",
    inviteToManagementToPitch: "Invite to Management Pitch",
    inManagementPitch: "In Management Pitch"
  },
  FILES: {
    COMMISSIONNING_PROTOCOL: "/files/MultiChoice_(Pty)_Ltd_commissioning_protocol_english.pdf",
    COMMISSIONNING_PROTOCOL_PT:"/files/MultiChoice_(Pty)_Ltd_commissioning_protocol_portuguese.pdf",
    COMMISSIONNING_PROTOCOL_AH:"/files/MultiChoice_(Pty)_Ltd_commissioning_protocol_amharic.pdf",
    COMMISSIONNING_PROTOCOL_KW:"/files/MultiChoice_(Pty)_Ltd_commissioning_protocol_kiswahili.pdf"
  },
  TABLE_STATUS: {
    0: "Submitted",
    1: "Draft",
    2: "In Review",
    3: "Re-work",
    4: "In Management Pitch",
    5: "Accepted",
    6: "Unsuccessful",
    7: "Virtual Pitch",
  },
  STATUS_NUMBER: {
    ZERO: 0,
    SEVEN: 7,
  },
  FOOTER: {
    ALL_RIGHTS: "© 2025 - All Rights Reserved",
  },
  PROPOSALS_TYPE: {
    0: "Solicited",
    1: "Unsolicited",
    2: "Solicited",
  },
  SUPPORTED_IMAGES: [
    "image/jpeg",
    "image/png",
    "image/svg",
    "image/gif",
    "image/jpg",
    "image/svg+xml",
  ],
  SUPPORTED_FILES: [
    "image/jpeg",
    "image/png",
    "image/svg",
    "image/gif",
    "image/jpg",
    "image/svg+xml",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ],
  CONFIG: {
    headers: {
      "Content-Type": "application/json",
    },
  },
  LOADERS: {
    LOADER_100X100: "images/loaders/Loader_100x100.gif",
    LOADER_200X200: "images/loaders/Loader_200x200.gif",
    SPINNING_LOADER: "../images/loaders/Spinning_loader.gif",
  },
  NOTIFICATION_LIMIT: 10000,
  MAX_COUNT: {
    ACTIVE_BRIEF_COUNT: 5,
    MY_PROPOSALS_COUNT: 20,
    TABLE_DATA_COUNT: 20,
    REQUEST_TAB_COUNT: 10,
  },
  SUPPORTED_IMAGES: [
    "image/jpeg",
    "image/png",
    "image/svg",
    "image/gif",
    "image/jpg",
    "image/svg+xml",
  ],
  ALL_RIGHTS: "© 2025 - All Rights Reserved",
  NO_DATA: "There is no data to display",
  VIDEOTUTORIALS: "Video Tutorials",
  CHANNEL_LOGO: {
    ABOLTV: "/channel-logo/AbolTV.svg",
    ABOLDUKA: "/channel-logo/AbolDuka.svg",
    AKWAABAMAGIC: "/channel-logo/AkwaabaMagic.svg",
    AFRICAMAGIC: "/channel-logo/AfricaMagic.svg",
    AFRICAMAGICSHOWCASE: "/channel-logo/AfricaMagicShowcase.svg",
    AFRICAMAGICFAMILY: "/channel-logo/AfricaMagicFamily.svg",
    CHANNELO: "/channel-logo/ChannelO.svg",
    KWENDAMAGIC: "/channel-logo/KwendaMagic.svg",
    KYKNET: "/channel-logo/KykNet.svg",
    KYKNETKIE: "/channel-logo/Kyk&Kie.svg",
    KYKNETNOU: "/channel-logo/kykNETNou.svg",
    MAADIIABOL: "/channel-logo/MaaddiiAbol.svg",
    MAISHAMAGICBONGO: "/channel-logo/MaishaMagicBongo.svg",
    MAISHAMAGICEAST: "/channel-logo/MaishaMagicEast.svg",
    MAISHAMAGICPLUS: "/channel-logo/MaishaMagicPlus.svg",
    MAISHAMAGICPOA: "/channel-logo/MaishaMagicPOA.svg",
    MANINGUEKOOL: "/channel-logo/ManingueKool.svg",
    MANINGUEMAGIC: "/channel-logo/ManingueMagic.svg",
    MNET: "/channel-logo/Mnet.svg",
    MNETMOVIES: "/channel-logo/Mnetovies.svg",
    MZANSIMAGIC: "/channel-logo/MzansiMagic.svg",
    MZANSIWETHU: "/channel-logo/MzansiWethu.svg",
    ONEZED: "/channel-logo/OneZed.svg",
    PEARLMAGIC: "/channel-logo/PearlMagic.svg",
    PEARLMAGICPRIME: "/channel-logo/PearlMagicPrime.svg",
    SHOWMAX: "/channel-logo/Showmax.svg",
    ZAMBEZIMAGIC: "/channel-logo/ZambesiMagic.svg",
  },
  NO_RESULTS_IMG: "/images/NoResult.svg",
  NO_RESULTS_MESSAGE: "No results found",
  NO_RESULTS_SUBMESSAGE: "Please alter your search and filter parameters and try again.",
  NO_RESULTS_DASHBOARD_MESSAGE: "Please alter your filter parameters and try again.",
  NO_DATA_FOUND_IMG: "/images/Illustrations.svg",
  EDIT_ICON: "/images/edit_icon.svg",
  DELETE_ICON: "/images/delete_icon.svg",
  NO_DATA_WITHOUTFILTER: "There is no data to display",
  FAQ_DROPDOWN: {
    HELP: "Help",
    FAQ: "FAQ",
    TICKETS: 'Tickets',
    VIDEOTUTORIALS: "Video Tutorials",
  },
  SEE_ALL: "See All",
  NOTIFICATIONS: "Notifications",
  SUPPORTED_IMAGES: [
    "image/jpeg",
    "image/png",
    "image/svg",
    "image/gif",
    "image/jpg",
    "image/svg+xml",
  ],
  ALL_RIGHTS: "© 2025 - All Rights Reserved",
  NO_DATA: "There is no data to display",
  VIDEOTUTORIALS: "Video Tutorials",
  NO_RESULTS: "No results found",
  NO_RESULTS_SUBMESSAGE: "Please alter your search and filter parameters and try again.",
  NO_NOTIFICATION: "No Notification Yet",
  Dashboard_Brief_card_Heading_BriefNo: "Brief ID",
  Dashboard_Brief_card_Heading_Type: "Type",
  Dashboard_Brief_card_Heading_Format: "Format",
  Dashboard_Brief_card_Heading_Genre: "Genre",
  Dashboard_Brief_card_Heading_Language: "Language",
  Dashboard_Brief_card_Heading_Closing_Date: "Closing Date",
  CLOSING_DATE: "Closing Date",
  CLOSE: "Close",
  RESOLVE:"Resolve",
  ACTIVATE_ACCOUNT: {
    PAGE_TITLE: "Activate your Account",
    COMPANY_NAME_TITLE: "Company Name",
    KEY_CONTACT_NAME_TITLE: "Key Contact Name",
    KEY_CONTACT_EMAIL_TITLE: "Key Contact Email",
    PRODUCER_NAME: "Name",
    PRODUCER_EMAIL: "Email",
    PASSWORD: "Password",
    RE_TRY_PASSWORD: "Re-Enter Password",
    BUTTON_TITLE: "Activate",
    PASSWORD_CRITERIA: {
      TITLE: "Password Criteria",
      CHARS_RANGE: "8-20 Characters",
      ATLEAST_1_UC: "At least 1 upper case letter",
      ATLEAST_1_NUM: "At least 1 number",
      NO_SPACE: "No spaces",
      ATLEAST_ONE_SPECIAL_CHARCTER: "At least 1 special character",
    },
    POPUP_MESSAGE: {
      SUCCESS: {
        TITLE: "Account Activated",
        MESSAGE:
          "Your account has been successfully activated. Please go back to the homepage and login to access the portal.",
        BUTTON_TEXT: "Go to Homepage",
      },
      FAILURE: {
        TITLE: "Account Activation Failed",
        MESSAGE:
          "There was an error with your activation of account. Please enter your details and try again. We’re sorry for the inconvenience.",
        BUTTON_TEXT: "Retry",
      },
    },
  },
  RESET_ACCOUNT_PASSWORD: {
    PAGE_TITLE: "Reset your Password",
    EMAIL: "Email",
    PASSWORD: "New Password",
    RE_TRY_PASSWORD: "Re-Enter Password",
    BUTTON_TITLE: "Reset Password",
    TOAST_SUCCESS: "Reset password link sent successfully",
    PASSWORD_CRITERIA: {
      TITLE: "Password must Include:",
      CHARS_RANGE: "8-20 Characters",
      ATLEAST_1_UC: "At least 1 upper case letter",
      ATLEAST_1_NUM: "At least 1 number",
      ATLEAST_1_SPECIAL_CHAR: "At least 1 special character",
      NO_SPACE: "No spaces",
    },
    POPUP_MESSAGE: {
      SUCCESS: {
        TITLE: "Password Reset Successfully",
        MESSAGE:
          "Your password has been reset successfully. Please go back to the homepage and login with the new password.",
        BUTTON_TEXT: "Go to Homepage",
      },
      FAILURE: {
        TITLE: "Password Reset Failed",
        MESSAGE:
          "There was an error with password reset. Please enter your details and try again. We’re sorry for the inconvenience.",
        BUTTON_TEXT: "Retry",
      },
    },
  },
  DEFAULTCHANNELLOGO: "/channel-logo/Default_Channel_logo.svg",
  DELETE_NEW_BRIEF: {
    POPUP: {
      delete: {
        TITLE: "Delete Brief",
        MESSAGE:
          "Are you sure you would like to delete the brief? Once deleted, the brief can no longer be retrieved.",
        BUTTON_TEXT: "Delete Brief",
      },
    },
  },
  EDIT_NEW_BRIEF: {
    HEADER_TITLE: "Create New Brief",
    SUBMIT_BRIEF: "Activate Brief",
    POPUP: {
      cross: {
        TITLE: "Abort Create New Brief",
        MESSAGE:
          "Are you sure you would like to abort the process of Create new Brief? All the data entered so far will be lost.",
        BUTTON_TEXT: "Abort",
      },
      cancel: {
        TITLE: "Cancel",
        MESSAGE:
          "Are you sure you would like to cancel the process of Create new Brief? All the data entered so far will be lost.",
        BUTTON_TEXT: "Cancel",
      },
      draft: {
        TITLE: "Save Brief as Draft",
        MESSAGE: "Are you sure you would like to save this brief as a draft?",
        BUTTON_TEXT: "Save as Draft",
      },
      brief: {
        TITLE: "Create Brief",
        MESSAGE:
          "Are you sure you would like to create this brief? Once created, the brief can’t be deleted.",
        BUTTON_TEXT: "Create Brief",
      },
      activate: {
        TITLE: "Activate Brief",
        MESSAGE:
          "Are you sure you want to activate this brief? Once activated, the brief can’t be deleted and can’t be shelved again.",
        BUTTON_TEXT: "Activate Brief",
      },
    },
  },
  CREATE_NEW_BRIEF: {
    HEADER_TITLE: "Create New Brief",
    GENRE: "Genre",
    DELETE: "Delete",
    FILTER_OPTIONS_NAME: {
      CHANNEL: "Channels",
      TYPE: "ProductionTypes",
      FORMAT: "Formats",
      GENRE: "Genres",
      LANGUAGE: "Languages",
    },
    POPUP: {
      cross: {
        TITLE: "Discard Brief without saving",
        MESSAGE:
          "Are you sure you would like to discard the brief without saving? Once discarded the brief can no longer be retrieved",
        BUTTON_TEXT: "Discard",
      },
      cancel: {
        TITLE: "Cancel",
        MESSAGE:
          "Are you sure you would like to cancel the process of Create new Brief? All the data entered so far will be lost.",
        BUTTON_TEXT: "Cancel",
      },
      draft: {
        TITLE: "Save Brief as Draft",
        MESSAGE: "Are you sure you would like to save this brief as a draft?",
        BUTTON_TEXT: "Save as Draft",
      },
      brief: {
        TITLE: "Create Brief",
        MESSAGE:
          "Are you sure you would like to create this brief? Once created, the brief can’t be deleted.",
        BUTTON_TEXT: "Create Brief",
      },
      activate: {
        TITLE: "Activate Brief",
        MESSAGE:
          "Are you sure you want to activate this brief? Once activated, the brief can’t be deleted and can’t be shelved again.",
        BUTTON_TEXT: "Activate Brief",
      },
    },
    POPUP_CREATE_BRIEF: {
      CANCEL: {
        TITLE: "Create Brief",
        MESSAGE:
          "Are you sure you would like to create this brief? Once created, the brief can’t be deleted.",
        BUTTON_TEXT: "Create Brief",
      },
    },
    POPUP_CANCEL: {
      CANCEL: {
        TITLE: "Cancel",
        MESSAGE:
          "Are you sure you would like to cancel the process of Create new Brief? All the data entered so far will be lost.",
        BUTTON_TEXT: "Cancel",
      },
    },
    POPUP_SAVE_AS_DRAFT: {
      CANCEL: {
        TITLE: "Save Brief as Draft",
        MESSAGE: "Are you sure you would like to save this brief as a draft?",
        BUTTON_TEXT: "Save as Draft",
      },
    },

    CHANNEL_LIST: ["Showmax", "Netflix", "Amazon"],
    CHANNELS_PLACEHOLDER: "Select a channel",
    LANGUAGE_LIST: ["English", "Afrikaans", "Swahili"],
    LANGUAGE_PLACEHOLDER: "Select a language",
    FORMAT_LIST: ["Film", "Series", "Documentary"],
    FORMAT_PLACEHOLDER: "Select a format",
    PRODUCT_TYPE_LIST: ["Full Commission", "Co-Production", "Acquisition"],
    PRODUCT_TYPE_PLACEHOLDER: " Select a production type",
    COMMISSIONING_EDITORS_LIST: ["Full Commission", "Co-Production", "Acquisition"],
    COMMISSIONING_EDITORS_PLACEHOLDER: " Jaylon Schleifer (you) + 4",
    CANCEL_BUTTON: "Cancel",
    SAVE_AS_DRAFT: "Save as Draft",
    CREATE_BRIEF: "Create Brief",
    BASIC_DETAILS: "Basic Details",
    BASIC_DETAILS_SUBTITLE: "Cluster:",
    BASIC_DETAILS_SUBTITLE_1: "Comedy",
    CHANNEL: "Channel",
    LANGUAGE: "Language",
    FORMAT: "Format",
    PRODUCTION_TYPE: "Production Type",
    DESCRIPTION: "Description",
    DESCRIPTION_PLACEHOLDER: "Once upon a time...",
    SUBMISSION_REQUIREMENT: "Submission Requirement",
    SUBMISSION_PLACEHOLDER: "Eg. Submit the following information.",
    CLOSING_DATE: "Closing Date",
    EVALUATION_INFORMATION: "Evaluation Information",
    CONTENT_COORDINATOR: "Content Co-ordinator",
    COMMISSIONING_EDITORS: "Commissioning Editors",
    CE_EVALUATION_DEADLINE: "CE Evaluation Deadline",
    SENIOR_MANAGER: "Senior Manager",
    SENIOR_MANAGER_EVALUATION_DEADLINE: "Senior Manager Evaluation Deadline",
    EVALUATION_PROCESS: "Evaluation Process",
    EVALUATION_PROCESS_PLACEHOLDER: "Proposal shall be evaluated based on...",
    PRODUCER_INFORMATION: "Producer Information",
    OPEN_BRIEF: "Open Brief",
    CLOSE_BRIEF: "Closed Brief",
    BRIEF_TYPE: "Brief Type",
    PRODUCERS: "Producers",
    SAVE: "Save",
    ADD_CRITERION: "+ Add Criterion",
    ADDITIONAL_COMMENTS: "Additional comments",
    ADDITIONAL_CRITERIA: "Additional criteria",
    CRITERIA_NAME: "Criteria Name (Optional)",
    EVALUATION_CRITERIA: "Evaluation Criteria",
    TOAST_BRIEF_DELETE_MSG: "Brief has been successfully deleted",
    TOAST_CREATE_BRIEF_SUCCESS: "Brief has been created successfully",
    TOAST_SAVE_AS_DRAFT_SUCCESS: "Brief has been successfully saved as draft",
    TOAST_EDIT_SUCCESS: "Brief has been created successfully",
  },
  BRIEF_FILTER_OPTIONS_NAME: {
    CHANNEL: "Channels",
    LANGUAGE: "Languages",
    FORMAT: "Formats",
    TYPE: "ProductionTypes",
  },
  UPDATE_NEW_USER_BASIC_INFORMATION: "Basic Information",
  ADD_NEW_CLUSTER_BASIC_INFO: "Basic Information",
  UPDATE_USER: {
    TITLE: "Update User",
    FOOTER_BTN_TITLE: "Update User",
    POPUP_MESSAGE: "Are you sure you want to update the user?",
    ABORT_POPUP_TITLE: "Abort Update User",
    ABORT_POPUP_MESSAGE:
      "Are you sure you would like to abort the user update? All the data entered so far will be lost.",
    ABORT_BUTTON_TEXT: "Abort",
    FAILURE_POPUP_TITLE: "Submission Failed",
    FAILURE_POPUP_MESSAGE:
      "There was an error with your user updation. Please enter your details and try again. We're sorry for the inconvenience.",
    FAILURE_BUTTON_TEXT: "Retry",
  },
  ADD_USER: {
    TITLE: "Add New User",
    FOOTER_BTN_TITLE: "Add User",
    POPUP_MESSAGE: "Are you sure you want to add a new user?",
    ABORT_POPUP_TITLE: "Abort Adding New User",
    ABORT_POPUP_MESSAGE:
      "Are you sure you would like to abort the process of adding new user? All the data entered so far will be lost.",
    ABORT_BUTTON_TEXT: "Abort",
    FAILURE_POPUP_TITLE: "Submission Failed",
    FAILURE_POPUP_MESSAGE:
      "There was an error with your user creation. Please enter your details and try again. We're sorry for the inconvenience.",
    FAILURE_BUTTON_TEXT: "Retry",
  },

  DELETE_USER: {
    TITLE: "Delete user",
    FOOTER_BTN_TITLE: "Delete user",
    POPUP_MESSAGE:
      "Are you sure you want to delete this user? Once deleted, the information cannot be restored.",
    SUCCESS_TOAST: "User has been successfully deleted.",
  },
  AllPROPOSALS: {
    RESULTS: "Briefs",
    AllPROPOSALS_TEXT: "All Proposals",
    SOLICITED: "Solicited",
    UNSOLICITED: "Unsolicited",
    PROPOSALS: "Proposals",
  },
  REASSIGN_BRIEF: {
    REASSIGN_BUTTON: "Apply",
    TITLE: "Apply for Brief",
  },
  EDIT_PROFILE: {
    POPUP: {
      cancel: {
        TITLE: "Confirm Cancellation",
        MESSAGE:
          "Are you sure you would like to abort the profile update? All the data entered so far will be lost.",
        BUTTON_TEXT: "Abort update profile",
      },
      retry: {
        TITLE: "retry",
        MESSAGE: "There was an error with the update of your profile. Please try again",
        BUTTON_TEXT: "retry",
      },
      Update: {
        TITLE: "Update Profile",
        MESSAGE: "Are you sure you want to update your company Profile?",
        BUTTON_TEXT: "Update Profile",
      },
    },
  },
  APPLY_BRIEF: {
    APPLY_BUTTON: "Apply",
    SUBMIT_BUTTON: "Submit",
    TITLE: "Apply for Brief",
    CANCEL_BUTTON: "Cancel",
    SAVE_AS_DRAFT: "Save as Draft",
    CREATE_BRIEF: "Create Brief",
    BASIC_DETAILS: "Basic details",
    PROPOSAL_DETAILS: "Proposal Details",
    COMPANY_INFORMATION: "Company & Regulatory Information",
    PROPOSAL_TITLE: "Proposal Title",
    EPISODE_STRUCTURE: "Episode Structure and Outline",
    CURRENCY: "Currency",
    PRELIMINARY_BUDGET: "Preliminary Budget",
    CAST_AND_PRESENTER_INFORMATION: "Cast and Presenter Information",
    SYNOPSIS: "Synopsis",
    EDITORIAL_DETAILS: "Editorial Details",
    PRODUCTION_SCHEDULE: "Pitch Deck",
    BRAND_INTEGRATION_OPPORTUNITIES: "Brand Integration Opportunities",
    ADVERSTISER_FUNDED: "Advertiser Funded Programme",
    LOGLINE: "Logline",
    LOOKBOOK_AND_MOODBOARD: "Lookbook and Moodboard",
    LOCATION_AND_STUDIO_INFORMATION: "Location and Studio Information",
    COMPANY_PROFILE_AND_TEAM_DETAILS: "Company Profile and Team Details",
    DESCRIPTION: "Description",
    SUBMITTION_REQUIREMENTS: "Submission Requirements",
    EVALUATION_SECTION: "The Evaluation Process",
    CHANNEL: "Channel",
    COUNTRY: "Country",
    FORMAT: "Format",
    GENRE: "Genre",
    SCRIPT: "Scripted / Non-scripted",
    LANGUAGE: "Language",
    PRODUCTION_TYPE: "Production Type",
    CLOSING_DATE: "Closing Date",
    SHOW_REEL: "Showreel of Previous Content or Shows ( .mp4 )",
    CERTIFICATE:
      "Certificate of Copyright/Registration for Originals Content ( .pdf or .doc or .ppt )",
    REGULAROTY: "Regulatory Documentation ( .pdf or .doc or .ppt )",

    CURRENCY_LIST: ["ZAR", "USD", "INR"],
    POPUP: {
      cross: {
        TITLE: " Discard Proposal Without Saving",
        MESSAGE:
          "Are you sure you would like to discard this proposal without saving? Once discarded, the proposal can no longer be retrieved.",
        BUTTON_TEXT: "Discard",
      },
      cancel: {
        TITLE: "Discard Proposal Without Saving",
        MESSAGE:
          "Are you sure you would like to discard this proposal without saving? Once discarded, the proposal can no longer be retrieved.",
        BUTTON_TEXT: "Cancel",
      },
      draft: {
        TITLE: "Save Proposal as Draft",
        MESSAGE: "Are you sure you would like to save this proposal as a draft?",
        BUTTON_TEXT: "Save as Draft",
      },
      brief: {
        TITLE: "Submit Proposal",
        MESSAGE: "Are you sure you would like to Submit your proposal",
        BUTTON_TEXT: "Submit Proposal",
      },
    },
  },
  SUBMIT_PROPOSAL: "Submit Proposal",
  SAVE_AS_DRAFT: "Save as Draft",
  SAVE_AS_DRAFT_PROMPT_TITLE: "Save Proposal as Draft",
  DISCARD: "Discard",
  ABORT: "Abort",
  ABORT_PROPOSAL_PROMPT_TITLE: "Abort Review Proposal",
  ABORT_PROPOSAL_PROMPT:
    "Are you sure you would like to abort the process of Reviewing Proposal? All the data entered so far will be lost.",
  DISCARD_PROPOSAL_PROMPT_TITLE: "Discard Proposal Without Saving",
  TOAST_DISCARD_PROPOSAL_PROMPT_TITLE: "Proposal has been successfully discarded",
  SUBMIT_UNSOLICITED_PROPOSAL_PROMPT_TITLE: "Submit Unsolicited Proposal",
  SAVE_DRAFT_PROMPT: "Are you sure you would like to save this proposal as a draft?",
  SUBMIT_PROPOSAL_PROMPT: "Are you sure you would like to save this unsolicited proposal for ",
  DISCARD_PROPOSAL_PROMPT:
    "Are you sure you would like to discard this proposal without saving? Once discarded, the proposal can no longer be retrieved.",
  TOTAL_DURATION: "Total Duration (in mins)",
  TOTAL_DURATION_PLACEHOLDER: "Eg. 120",
  NEW_GENRE: "Other Genre",
  NEW_GENRE_PLACEHOLDER: "Eg. Adventure",
  LANGUAGE_SELECT_PLACEHOLDER: "Please select channel first",
  CLUSTER_SELECT_PLACEHOLDER: "Please select country & script type",
  OTHER: "Other",
  EDIT_UNSOLICITED_PROPOSAL_TITLE: "Edit Unsolicited Proposal",
  DELETE_UNSOLICITED_PROPOSAL_PROMPT:
    "Are you sure you would like to delete this proposal? Once deleted, the proposal can no longer be retrieved.",
  DELETE_PROPOSAL: "Delete Proposal",
  producerId: "ef3f90b4-b17f-47d2-ad4f-ed5737da61a4",
  TOAST_INFO_DELETE_MSG: "Proposal has been successfully deleted",
  TOAST_INFO_DISCARD_MSG: "Proposal has been discarded successfully",
  FAILED_DELETE_PROPOSAL: "Error in deleting this proposal.",
  TOAST_PROFILE: "Profile updated successfully",
  EDIT_UNSOLICITED_PROPOSAL_TITLE: "Edit Unsolicited Proposal",
  HALF_PAGE_MESSAGE: "Uh oh! Looks like there was an error in loading the data.",
  HALF_PAGE_SUB_MESSAGE: "Please click on Reload to try reloading information.",
  UNSOLICITED_TOOLTIP_LOGLINE:
    "A one or two-sentence summary of a story that captures its premise, key characters, and central conflict, designed to grab interest quickly.",
  UNSOLICITED_TOOLTIP_SYNOPSIS:
    "A concise summary that provides a brief overview of the main plot points, characters, and central conflict of a narrative, providing an overview of how the story unfolds without going into excessive detail.",
  UNSOLICITED_TOOLTIP_EPISODE_ST_OUTLINE:
    "Refers to how an episode is organized, including its key components, such as the introduction, conflict, climax, and resolution. It often follows a specific format based on the show’s genre and storytelling style. An outline is a structured summary that breaks down the key plot points, character developments, and major events in a logical sequence, serving as a blueprint for writing the script.",
  UNSOLICITED_TOOLTIP_BRAND_INTEGRATION:
    "Refers to moments within a show where a brand or product can be naturally woven into the storyline, settings, or character interactions to enhance brand visibility and engagement.",
  TOOLTIP_COMPANY:
    "Is a brief document or presentation that outlines a company’s mission, history, services, and key achievements, providing an overview of its identity and operations. The company’s team details provides information about the key members of an organization, including their roles, expertise, and contributions, showcasing the talent and leadership behind the company.",
  BAD_REQ: "BadRequest",
  PROPOSAL_SUBMIT_SUCCESS: "Proposal review has been submitted successfully",
  PROPOSAL_SUBMIT_SUCCESS_PRODUCER: "Proposal has been submitted successfully",
  PROPOSAL_SAVE_SUCCESS: "Proposal has been successfully saved",
  PRODUCER_MANDATORY_FIELDS_API_KEYS: {
    COMPANY_REG_NUM: "companyregistrationno",
    COMPANY_NAME: "companyname",
    EMAIL: "email",
    VAT_REG_NUM: "vatregistrationno",
    VEN_REG_NUM: "vendorregistrationno",
  },
  EXTERNAL_LINKS: {
    PRIVACY_NOTICE_URL: "https://www.multichoice.com/privacy-notice.php",
    EXERCISE_YOUR_RIGHTS_URL: "https://www.multichoice.com/exercise-your-rights.php",
  },
  ADD_NEW_CLUSTER: {
    TITLE: "Add New Cluster",
    BASIC_INFO: "Basic Information",
    NAME_PLACEHOLDER: "Eg. Kenya Scripted",
    NAME_TITLE: "Name",
    SCORE_TITLE: "Cluster Approval Score",
    SCORE_PLACEHOLDER: "Eg. 7",
    COUNTRY_TITLE: "Country",
    COUNTRY_PLACEHOLDER: "Eg. Kenya",
    SCRIPTED_TITLE: "Scripted/Non-scripted",
    SCRIPTED_PLACEHOLDER: "Eg. Scripted",
    GENRE_TITLE: "Genre",
    GENRE_PLACEHOLDER: "Eg. Comedy",
    FOOTER_BTN_TITLE: "Add Cluster",
    POPUP_MESSAGE: "Are you sure you want to add a new cluster?",
    ABORT_POPUP_TITLE: "Abort Adding New Cluster",
    ABORT_POPUP_MESSAGE:
      "Are you sure you would like to abort the process of adding new cluster? All the data entered so far will be lost.",
    ABORT_BUTTON_TEXT: "Abort",
    FAILURE_POPUP_TITLE: "Submission Failed",
    FAILURE_POPUP_MESSAGE:
      "There was an error with your cluster creation. Please enter your details and try again. We're sorry for the inconvenience.",
    ERROR_POPUP_MESSAGE1: "The selected cluster combination ",
    ERROR_POPUP_MESSAGE2: " is already in use. Please select a different cluster and try again.",
    FAILURE_BUTTON_TEXT: "Retry",
    SUCCESS_TOAST: "New cluster has been successfully added.",
  },
  UPDATE_CLUSTER: {
    TITLE: "Update Cluster",
    FOOTER_BTN_TITLE: "Update Cluster",
    POPUP_MESSAGE: "Are you sure you want to update the cluster?",
    ABORT_POPUP_TITLE: "Abort Update Cluster",
    ABORT_POPUP_MESSAGE:
      "Are you sure you would like to abort the cluster update? All the data entered so far will be lost.",
    ABORT_BUTTON_TEXT: "Abort",
    FAILURE_POPUP_TITLE: "Submission Failed",
    FAILURE_POPUP_MESSAGE:
      "There was an error with your cluster updation. Please enter your details and try again. We're sorry for the inconvenience.",
    FAILURE_BUTTON_TEXT: "Retry",
    SUCCESS_TOAST1: "Cluster, ",
    SUCCESS_TOAST2: " has been successfully updated.",
  },
  DELETE_CLUSTER: {
    TITLE: "Delete Cluster",
    FOOTER_BTN_TITLE: "Delete Cluster",
    POPUP_MESSAGE:
      "Are you sure you want to delete this cluster? Once deleted, the cluster information cannot be restored.",
    SUCCESS_TOAST: "Cluster has been successfully deleted.",
    POPUP_MESSAGE_UNDELETE:
      "The cluster cannot be deleted due to users or proposals currently assigned to it. Please re-assign the users or proposals to a different cluster before deletion.",
  },
  ADD_NEW_USER_NAME_PLACEHOLDER: "Eg. John Doe",
  ADD_NEW_USER_EMAIL_PLACEHOLDER: "Eg. Johndoe@multichoice.com",
  ADD_NEW_USER_DESIGNATION_PLACEHOLDER: "Eg. Content Co-ordinator",
  ADD_NEW_HOP_USER_DESIGNATION_PLACEHOLDER: "Eg. Head Of Production",
  ADD_NEW_USER_CLUSTER_REGION_PLACEHOLDER: "Eg. Kenya/ Scripted",
  ADD_NEW_USER_REPORTING_TO_PLACEHOLDER: "Eg. John Doe",
  ADD_NEW_USER_PHONE_NUMBER_PLACEHOLDER: "Eg. +225 0193941743",
  ADD_NEW_USER_LOCATION_PLACEHOLDER: "Eg. Kenya",
  UPDATE_NEW_USER: "Update User",
  ADD_NEW_USER: "Add New User",
  ADDUSER_PROMPT:
    "Are you sure you want to add a new user?.Upon adding a new user an activation link will be sent to their email address for them to login",
  ADDUSER_CANCEL: "Cancel",
  ADD_NEW_USER_NAME_TITLE: "Name",
  ADD_NEW_USER_BASIC_INFORMATION: "Basic Information",
  ADD_NEW_USER_EMAIL_TITLE: "Email",
  ADD_NEW_USER_DESIGNATION_TITLE: "Designation(s)",
  ADD_NEW_USER_CLUSTER_TITLE: "Cluster(s)",
  ADD_NEW_USER_REPORTING_TO: "Reporting To",
  ADD_NEW_USER_PHONE_NUMBER: "Phone Number",
  ADD_NEW_USER_LOCATION: "Location",
  ADD_NEW_USER_FOOTER_BTN_TITLE: "Add User",
  ADD_NEW_USER_SUCCESS_TOAST: "New user has been successfully added.",
  UPDATE_USER_SUCCESS_TOAST: "User has been successfully updated.",
  FETCH_CREATEDBY: "CREATEDBY",
  FETCH_REQUESTEDBY: "REQUESTEDBY",
  FETCH_PROPOSALSTATUS: "STATUS",
  FETCH_PRODUCER: "PRODUCER",
  UNSOLICITED_FAILED_POPUP_TITLE: "Failed to Submit Unsolicited Proposal",
  UNSOLICITED_FAILED_SAVE_POPUP_TITLE: "Failed to Save Unsolicited Proposal",
  SOLICITED_FAILED_SAVE_POPUP_TITLE: "Failed to Save Solicited Proposal",
  DRAFT: "draft",
  SOLICITED_FAILED_POPUP_TITLE: "Failed to Submit Solicited Proposal",
  UNSOLICITED_FAILED_POPUP_MESSAGE:
    "There was an error with your proposal submission. Please enter your details and try again. We're sorry for the inconvenience.",
  CC_UNSOLICITED_PROPOSAL_STATUS: {
    ACCEPTED: "Accepted",
    UNSUCCESSFUL: "Unsuccessful",
    INVITE_TO_VIRTUAL_PITCH: "Invite to Virtual Pitch",
    IN_VIRTUAL_PITCH: "In Virtual Pitch",
    IN_CE_REVIEW: "In CE Review",
    IN_SM_REVIEW: "In SM Review",
    TO_BE_ASSIGNED: "To be Assigned",
    REWORK: "Re-work",
    INVITE_TO_MANAGEMENTS_PITCH: "Invite to Management Pitch",
    IN_MANAGEMENT_PITCH: "In Management Pitch",
    RE_ASSIGN_REQUESTED: "Re-Assign Requested",
  },
  CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES: {
    CLOSE: "Close",
    REJECT_PROPOSAL: "Reject Proposal",
    ASSIGN_PROPOSAL: "Assign Proposal",
    RE_ASSIGN_PROPOSAL: "Re-assign Proposal",
    INVITE_TO_VIRTUAL_PITCH: "Invite to Virtual Pitch",
    UNSUCCESSFUL: "Unsuccessful",
    ASSIGN_SM_EVALUATION: "Assign for SM Evaluation",
    SEND_RE_WORK_MAIL: "Send Re-work Mail",
    INVITE_MANAGEMENT_PITCH: "Invite to Management Pitch",
    ACCEPTED: "Accepted",
    SEND_MAIL: "Send Mail",
  },
  CC_SOLICITED_PROPOSAL_STATUS: {
    ACCEPTED: "Accepted",
    UNSUCCESSFUL: "Unsuccessful",
    INVITE_TO_VIRTUAL_PITCH: "Invite to Virtual Pitch",
    IN_VIRTUAL_PITCH: "In Virtual Pitch",
    IN_CE_REVIEW: "In CE Review",
    IN_SM_REVIEW: "In SM Review",
    TO_BE_ASSIGNED: "To be assigned",
    REWORK: "Re-work",
    INVITE_TO_MANAGEMENTS_PITCH: "Invite to Management Pitch",
    IN_MANAGEMENT_PITCH: "In Management Pitch",
  },
  CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES: {
    CLOSE: "Close",
    REJECT_PROPOSAL: "Reject Proposal",
    ASSIGN_PROPOSAL: "Assign Proposal",
    RE_ASSIGN_PROPOSAL: "Re-assign Proposal",
    INVITE_TO_VIRTUAL_PITCH: "Invite to Virtual Pitch",
    UNSUCCESSFUL: "Unsuccessful",
    ASSIGN_SM_EVALUATION: "Assign for SM Evaluation",
    ASSIGN_HOP_EVALUATION:"Assign for HOP Evaluation",
    SEND_RE_WORK_MAIL: "Send Re-work Mail",
    INVITE_MANAGEMENT_PITCH: "Invite to Management Pitch",
    ACCEPTED: "Accepted",
    SEND_MAIL: "Send Mail",
  },
  CC_UNSOLICITED_STATUS: {
    0: "To be assigned",
    1: "In CE Review",
    2: "Invite to Virtual Pitch",
    3: "In Virtual Pitch",
    4: "In SM Review",
    5: "Invite to Management Pitch",
    6: "In Management Pitch",
    7: "Unsuccessful",
    8: "Accepted",
    9: "Re-work",
  },
  CC_UNSOLICITED_IMG: {
    ACCEPTED: "/images/greenlit.svg",
    UNSUCCESSFUL: "/images/unsuccess.svg",
    MANAGEMENTPITCH: "/images/mail.svg",
    INVITETOMANAGEMENTPITCH: "/images/mail.svg",
    INSMREVIEW: "/images/searchIcon.svg",
    INVITETOVIRTUALPITCH: "/images/mail.svg",
    REWORK: "/images/Rework.svg",
    INVIRTUALPITCH: "/images/pitchUncolored.svg",
    TOBEASSIGNED: "/images/shelved.svg",
    INCEREVIEW: "/images/searchIcon.svg",
    REVIEWPENDING: "/images/shelved.svg",
  },
  UNSOLICITED_ERROR_MSG: {
    PROPOSALTITLE: "Please enter proposal title",
    SYNOPSIS: "Please enter synopsis",
    LOGLINE: "Please enter logline",
    EPISODESTRUCTUREOUTLINE: "Please enter episode structure and outline",
    EDITORIALDETAILS: "Please enter editorial details",
    LOCATIONSTUDIOINFO: "Please enter location and studio information",
    CASTPRESENTERINFO: "Please enter cast and presenter information",
    BRANDINTEGRATIONOPPORTUNITIES: "Please enter brand integration opportunities",
    KEYTEAM: "Please enter key team",
    NEWGENRE: "Please enter genre",
    TARGETBUDGET: "Please enter target budget",
    COUNTRY: "Please select country",
    SCRIPTEDUNSCRIPTED: "Please select scripted or non-scripted",
    GENRE: "Please select genre",
    CHANNEL: "Please select channel",
    LANGUAGE: "Please select language",
    PRODUCTIONTYPE: "Please select production type",
    TARGETAUDIENCE: "Please select target audience",
    FORMAT: "Please select format",
    CURRENCY: "Please select currency",
    DURATION: "Please enter duration",
    PRELIMINARYBUDGET: "Please enter preliminary budget",
    CMPPROFILEANDTEAMDETAILS: "Please enter company profile and team details",
    EPISODE_LESS_THAN_7:"Please enter a number above 7",
    MINI_EPISODES_NOT_IN_RANGE:"Please enter a number from 1 to 7",
    INVALID_EPISODE_DURATION:"Please enter a valid episode duration"
  },
  USER_ROLES: {
    ADMIN: '1',
    SNR_MGR: '2',
    CE: '3',
    CC: '4',
    PRODUCER: '5',
    SA:'1',
    HOP:'6'
  },
  TIMELINE_STATUS: {
    PRODUCER: {
      0: "Submitted",
      1: "Draft",
      2: "In Review",
      3: "Rework",
      // 4: "Invite To Pitch",
      4: "In Management Pitch",
      5: "Accepted",
      6: "Unsuccessful",
      // 7: "To Be Invited",
      7: "In Virtual Pitch",
    },
    CC: {
      0: "To Be Assigned",
      1: "In CE Review",
      2: "Invite to Virtual Pitch",
      3: "In Virtual Pitch",
      4: "In SM Review",
      5: "Invite to Management Pitch",
      6: "In Management Pitch",
      7: "Unsuccessful",
      8: "Accepted",
      9: "Re-work",
      11:"In Hop Review"
    },
    CE: {
      0: "To Be Assigned",
      1: "In CE Review",
      2: "Invite to Virtual Pitch",
      3: "In Virtual Pitch",
      4: "In SM Review",
      5: "Invite to Management Pitch",
      6: "In Management Pitch",
      7: "Unsuccessful",
      8: "Accepted",
      9: "Re-work",
      11:"In Hop Review"
    },
    SM: {
      0: "To Be Assigned",
      1: "In CE Review",
      2: "Invite to Virtual Pitch",
      3: "In Virtual Pitch",
      4: "In SM Review",
      5: "Invite to Management Pitch",
      6: "In Management Pitch",
      7: "Unsuccessful",
      8: "Accepted",
      9: "Re-work",
      11: "In HOP Review"
  },
  HOP:{
    0: "To Be Assigned",
      1: "In CE Review",
      2: "Invite to Virtual Pitch",
      3: "In Virtual Pitch",
      4: "In SM Review",
      5: "Invite to Management Pitch",
      6: "In Management Pitch",
      7: "Unsuccessful",
      8: "Accepted",
      9: "Re-work",
      11: "In HOP Review"
  },
  SA:{
    0: "To Be Assigned",
      1: "In CE Review",
      2: "Invite to Virtual Pitch",
      3: "In Virtual Pitch",
      4: "In SM Review",
      5: "Invite to Management Pitch",
      6: "In Management Pitch",
      7: "Unsuccessful",
      8: "Accepted",
      9: "Re-work",
      11:"In Hop Review"
  }
  },
  CC_CE_COMMENTS: "Email Content",
  INVITE_TO_MANAGEMENT_PITCH: {
    MESSAGE:
      "Are you sure you want to invite the producer for an Management Pitch? Once sent, the request cannot be reversed.",
    TITLE: "Invite to Management Pitch",
    BUTTON_TEXT: "Invite to Management Pitch",
    TOAST_SUCCESS: "Invite for in-management pitch sent successfully",
    POPUP_EMAIL_HEADER:
      "Thank you for attending the Virtual Pitch. We would like to proceed to the second phase of the pitching process and invite you to present your pitch in management. This is to determine if your submission meets our business needs and requirements.",
  },
  INVITE_TO_VIRTUAL_PITCH: {
    MESSAGE: "Are you sure you want to invite the producer for a Virtual Pitch?",
    TITLE: "Invite to Virtual Pitch",
    BUTTON_TEXT: "Invite to Virtual Pitch",
    TOAST_SUCCESS: "Invite to Virtual Pitch has been sent successfully",
    POPUP_EMAIL_HEADER:
      "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we would like to invite you to attend a virtual pitch.",
  },
  REJECTION_MAIL_VIRTUAL_PITCH: {
    MESSAGE:
      "Are you sure you want to send an unsuccessful email to the producer? Once sent, the email cannot be reversed.",
    TITLE: "Send Unsuccessful Mail",
    BUTTON_TEXT: "Send Mail",
    TOAST_SUCCESS: "Unsuccessful proposal mail has been sent successfully",
    SUB_TITLE: "Reasons for Rejection",
    PLACEHOLDER: "Select Reasons",
    POPUP_EMAIL_HEADER:
      "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we will not be proceeding with your submission.",
  },
  IN_MANAGEMENT_PITCH: {
    ACCEPTED: {
      MESSAGE:
        "Are you sure you want to send an acceptance email to the producer? Once sent, the email cannot be reversed.",
      TITLE: "Send Acceptance Mail",
      BUTTON_TEXT: "Send Mail",
      TOAST_SUCCESS: "Acceptance mail has been sent successfully",
      POPUP_EMAIL_HEADER:
        "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we would like to recommendation the below changes be implemented for further review.",
    },
    UNSUCCESSFUL: {
      MESSAGE:
        "Are you sure you want to send an unsuccessful email to the producer? Once sent, the email cannot be reversed.",
      TITLE: "Send Unsuccessful Mail",
      BUTTON_TEXT: "Send Mail",
      TOAST_SUCCESS: "Unsuccessful proposal mail has been sent successfully",
      POPUP_EMAIL_HEADER:
        "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we will not be proceeding with your submission.",
    },
  },
  UNSUCCESSFUL: {
    MESSAGE:
      "Are you sure you want to send an unsuccessful email to the producer? Once sent, the email cannot be reversed.",
    TITLE: "Send Unsuccessful Mail",
    BUTTON_TEXT: "Send Mail",
    TOAST_SUCCESS: "Unsuccessful proposal mail has been sent successfully",
    POPUP_EMAIL_HEADER:
      "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we will not be proceeding with your submission.",
  },
  RE_WORK: {
    MESSAGE:
      "Are you sure you want to send a re-work email to the producer? Once sent, the email cannot be reversed.  ",
    TITLE: "Send Re-work Mail",
    BUTTON_TEXT: "Send Mail",
    TOAST_SUCCESS: "Re-work mail has been sent successfully",
    POPUP_EMAIL_HEADER:
      "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we would like to recommendation the below changes be implemented for further review.",
  },
  TOAST_FAILURE: "Error : Action was unsuccessful. Please try again.",
  HALF_PAGE_BRIEF_DETAILS: {
    NA:"N/A",
    BRIEF_DETAILS_HEADER: "Brief Details",
    BRIEF_DETAILS_DESC_TITLE: "Description",
    BRIEF_DETAILS_DESC:
      "Showmax Kenya is excited to announce that we are accepting pitches for a new original series to air on our platform. We are committed to delivering engaging, high-quality content that resonates with our diverse audience. This initiative aims to explore fresh, compelling stories that reflect the spirit of our channel and provide meaningful entertainment.",
    SUBMISSION_REQUIREMENTS_TITLE: "Submission Requirements",
    SUBMISSION_INFO: "Include the following in your proposal:",
    UL_ITEM1: "Logline: One-sentence movie summary.",
    UL_ITEM2: "Synopsis: Brief outline (up to 500 words).",
    UL_ITEM3: "Treatment: 2–3 page narrative breakdown.",
    UL_ITEM4: "Target Audience: Who the movie is for and why it will resonate.",
    UL_ITEM5: "Bio: Short profile of the writer(s) and producer(s).",
    EVALUTION_PROCESS_TITLE: "Evaluation Process",
    EVALUATION_UL_ITEM1: " Receipt of proposals will be acknowledged by portal notification.",
    EVALUATION_UL_ITEM2:
      "• Proposals will be evaluated by a panel of Evaluators selected by Showmax Management.",
    EVALUATION_UL_ITEM3:
      "• If successful, shortlisted proposals will be invited through email for a pitching session.",
    EVALUATION_PROCESS_INFO1: "Our selection process will take approximately 8 weeks. ",
    EVALUATION_PROCESS_INFO2:
      "If you don’t hear from us within 90 days after the submission deadline, consider your application unsuccessful.",
    SHELVE_POP_UP_DESC1:
      "Are you sure you want to shelve this brief? Once shelved, an approval request will be sent to ",
    SHELVE_POP_UP_DESC2:
      " (SM).\nAll proposals for this brief will be rejected and the relevant Producer will be notified.",
    REACTIVATE_POP_UP_DESC:
      "Are you sure you want to activate this brief? Once activated, the brief cannot be deleted or re-shelved.",
    CREATED_BY: "Created by",
    CLOSING_DATE: "Closing date",
    CHANNEL: "Channel",
    FORMAT: "Format",
    PRODUCTION_TYPE: "Production Type",
    REGION: "Region",
    SCRIPTED_UNSCRIPTED: "Scripted / Unscripted",
    GENRE: "Genre",
    LANGUAGE: "Language",
    VIEW_PROPOSALS: "View Proposals",
    RE_ASSIGN_BRIEF: "Re-assign Brief",
    RE_ASSIGN_BRIEF_BTN_TEXT: "Re-assign Brief",
    SHELVE_BRIEF: "Shelve Brief",
    SM_ROLE_ID: 2,
    SHELVE_BRIEF1: "Shelve Brief",
    REACTIVATE_BRIEF: "Re-activate Brief",
    ACTIVATE_BRIEF: "Activate Brief",
    CURRENT_CLUSTER: "Current Cluster",
    CLUSTER: "Cluster",
    CHANNEL: "Channel",
    RE_ASSIGN_TO_NEW_CLUSTER: "Re-assign to New Cluster",
    CANCEL: "Cancel",
    SELECT_CLUSTER: "Select Cluster",
    SELECT_CHANNEL: "Select Channel",
    COMMENTS: "Comments",
    COMMENTS_PLACEHOLDER:
      "This brief fits better into the region of South Africa since the content type is suited more towards the audiences of South Africa, Eswatini and Lesotho.",
    RE_ASSIGN_POP_UP_DESC1:
      "Are you sure you want to re-assign this brief? Once re-assigned, an approval request will be sent to ",
    RE_ASSIGN_POP_UP_DESC2:
      "(SM). \nThe brief will no longer be visible on your profile once re-assigned to another cluster.",
    RE_ASSIGN_PROPOSAL_POP_UP_DESC1:
      "Are you sure you want to re-assign this proposal? Once re-assigned, an approval request will be sent to ",
    RE_ASSIGN_PROPOSAL_POP_UP_DESC2:
      "(SM).\nThe proposal will no longer be visible on your profile once re-assigned to another cluster.",
    CLUSTER_ERROR: "Please Select Cluster",
    CHANNEL_ERROR: "Please Select Channel",
    INVALID_CHANNEL_ERROR: "Please select different channel",
    ACTION_BUTTON_TEXT: "Re-AssignBtnClick",
    EDIT_BUTTON_TEXT: "Edit",
    RE_ACTIVE_BRIEF: "Re-active Brief",
    RE_ASSIGN_PROPOSAL: "Re-assign Proposal",
    CLOSE: "Close",

    STATUS: {
      DRAFT: "Draft",
      ACTIVE: "Active",
      SUBMISSIONS_CLOSED: "Submissions Closed",
      IN_REVIEW: "In Review",
      SHELVED: "Shelved",
      GREEN_LIT: "Green Lit",
      EXPIRED: "Expired",
      SHELVE_REQUESTED: "Shelve Requested",
      REASSIGN_REQUESTED: "Re-Assign Requested",
    },
    SHELVE_BRIEF_TOAST_SUCCESS: "Shelve request has been sent successfully",
    REACTIVATE_BRIEF_TOAST_SUCCESS: "Brief has been re-activated successfully",
    REASSIGN_BRIEF_TOAST_SUCCESS: "Brief re-assign request has been sent successfully",
    REASSIGN_PROPOSAL_TOAST_SUCCESS: "Proposal re-assign request has been sent successfully",
  },
  TOAST_FAILURE: "Error : Action was unsuccessful. Please try again.",
  CE_PROPOSAL_STATUS: {
    REVIEW_PENDING: "Review Pending",
    IN_CE_REVIEW: "In CE Review",
    INVITE_TO_VIRTUAL_PITCH: "Invite to Virtual Pitch",
    IN_VIRTUAL_PITCH: "In Virtual Pitch",
    IN_SM_REVIEW: "In SM Review",
    REWORK: "Re-work",
    INVITE_TO_MANAGEMENTS_PITCH: "Invite to Management Pitch",
    IN_MANAGEMENT_PITCH: "In Management Pitch",
    ACCEPTED: "Accepted",
    UNSUCCESSFUL: "Unsuccessful",
  },
  CE_STATUS_BTN_TITLES: {
    RE_ASSIGN_PROPOSAL: "Re-assign",
    REVIEW_PROPOSAL: "Review Proposal",
  },
  INTERNAL_MANAGEMENT: {
    INTERNAL_MANAGEMENT_TEXT: "Internal Management",
    CLUSTER_MANAGEMENT: "Cluster Management",
    USER_MANAGEMENT: "User Management",
    RESULTS_USERS: "Users",
    RESULTS_CLUSTERS: "Clusters",
    REGION: "Country",
    GENRE: "Genre",
    CREATION_DATE: "Creation date",
    REGISTRATION_DATE: "Registration date",
    CLUSTER: "Cluster",
    DESIGNATION: "Designation",
    REGIONS: "REGION",
  },
  SYS_ADMIN: {
    APPROVE_REJECT_UI: {
      TITLE_OLD: "Company Registration Approval",
      TITLE: "Producer Details",
    },
    PRODUCER_UI: {
      TITLE_OLD: "Individual Producer Registration Approval",
      TITLE: "Producer Details",
      PRODUCER_INFO: "Producer Information",
      NAME: "Name",
      LOGO_PIC: "Logo/Picture",
    },
    CTA: {
      REJECT: "Reject",
      APPROVE: "Approve",
      CLOSE: "Close",
    },
    POPUP: {
      APPROVE_POPUP_TITLE: "Approve Company Registration",
      APPROVE_PRODUCER_POPUP_TITLE: "Approve Individual Producer Registration",
      EMAIL_CONTENT: "Email Content",
      APPROVE_PRODUCER_PROMPT_L1:
        "Are you sure you want to approve the registration of this Individual Producer?",
      APPROVE_PROMPT_L1: "Are you sure you want to approve the registration of this Company?",
      APPROVE_PRODUCER_PROMPT_L2:
        "Once approved, an activation link will be sent to the Individual Producer's email address to login.",
      APPROVE_PROMPT_L2:
        "Once approved, an activation link will be sent to the Company’s email address to login.",
      REJECT_POPUP_TITLE: "Reject Company Registration",
      REJECT_POPUP_PRODUCER_TITLE: "Reject Individual Producer Registration",
      REJECT_PROMPT_L1: "Are you sure you want to reject the registration of the Company?",
      REJECT_PROMPT_PRODUCER_L1:
        "Are you sure you want to reject the registration of this Individual Producer?",
      REJECT_PROMPT_PRODUCER_L2:
        "Once rejected, the Individual Producer data will be discarded, and they will not receive an activation link.",
      REJECT_PROMPT_L2:
        "Once rejected, the Company data will be discarded and they will not be able to login.",
      REJECT_EMAIL_TEMPLATE:
        "Unfortunately, your registration on the GE Submissions Portal has been unsuccessful due to incomplete or inaccurate data. We are unable to complete your registration.",
      REJECT_EMAIL_TEMPLATE_FOOTER: "Regards,\n Administrator",
    },
    TOAST_MESSAGE: {
      REJECT_COMP: "Company registration unsuccessful. Rejection mail sent to the Company's email.",
      APPROVE_COMP: "Company registration successful. Activation link sent to the Company's email.",
      APPROVE_PRODUCER:
        "Individual Producer registration successful. Activation link sent to the Producer's email.",
      REJECT_PRODUCER:
        "Individual Producer registration unsuccessful. Rejection mail sent to the Producer's email.",
      ERROR: "Error : Action was unsuccessful. Please try again.",
    },
  },
  SENIOR_MANAGER: {
    CE_EVALUATION: "CE Evaluation",
    SCORE: "Score : ",
    SHOW_SCORES_TEXT: "Show Score",
    HIDE_SCORE_TEXT: "Hide Scores",
    SCORE_DESCRIPTION:
      "Characters can have more depth. The character development arc planned for the 2 main characters can be developed further to increase the intensity and longetivity of the show.",
    EVALUATION_CRITERIA: "Evaluation Criteria",
    FINAL_SCORE: "Final Score : ",
    SCORING_STATUS: "Scoring Status : ",
    SUBMIT_BTN_TEXT: "Submit",
    COMMENTS: "Comments",
    CE_EVALUATION_DEADLINE: "CE Evaluation Deadline",
    SM_EVALUATION_DEADLINE: "SM Evaluation Deadline",
    SM_EVALUATION: "Senior Manager Evaluation",
    DEADLIN_PLACE_HOLDER: "Eg. 25 Feb 2025",
    OPTIONS: {
      RE_WORK: "Re Work",
      INVITE_TO_MANAGEMENT_PITCH: "Invite to management Pitch",
      UNSUCCESSFUL: "UnSuccessful",
      INVITE_TO_VIRTUALPITCH:"Invite to Virtual Pitch"
    },
    RE_WORK_POP_UP_TITLE: "Confirm Evaluation - Re-work",
    RE_WORK_POP_UP_DESC: "Are you sure you would like to submit this evaluation?",
    INVITE_TO_IN_MANAGEMENT_PITCH_POP_UP_TITLE: "Confirm Evaluation - Invite to Management Pitch",
    UNSUCCESSFUL_POP_UP_TITLE: "Confirm Evaluation - Invite to Management Pitch",
    SUBMIT_BTN_TEXT: "Submit",
    TEXT_AREA_ERROR: "Please enter comments.",
    CE_DEADLINE_ERROR_MSG: "Please select CE Deadline",
    SM_DEADLINE_ERROR_MSG: "Please select SM DeadLine",
    SUBMIT_BTN_TOAST_SUCCESS_MSG: "Evaluation has benn successfylly submitted!",
    POPUP: {
      RE_WORK: {
        TITLE: "Confirm Evaluation - Re-work",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
      INVITE_TO_MANAGEMENT_PITCH: {
        TITLE: "Confirm Evaluation - Invite to Management Pitch",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
      UNSUCCESSFUL: {
        TITLE: "Confirm Evaluation - Unsuccessful ",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
       INVITE_TO_VIRTUAL_PITCH: {
        TITLE: "Confirm Evaluation - Invite to Virtual Pitch ",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },

      cross: {
        TITLE: "Discard Evaluation without saving",
        DESCRIPTION:
          "Are you sure you would like to discard the brief without saving? Once discarded the brief can no longer be retrieved",
        BUTTON_TEXT: "Discard",
      },
    },
  },
  REQUEST: {
    BRIEF_RE_ASSIGN: "Brief Re-assign",
    PROPOSAL_RE_ASSIGN: "Proposal Re-assign",
    BRIEF_SHELVE: "Brief Shelve",
    USER_APPROVAL: "User Approval",
    REQUESTS: "Requests",
    RESULTS: "Results",
    CTA_APPROVE: "Approve",
    CTA_REJECT: "Reject",
  },
  BRIEF_REASSIGN: {
    ARPPOVE_POPUP: {
      TITLE1: "Approve Brief ",
      TITLE2: " Re-assignment",
      PROMPT_TEXT: `Are you sure you want to approve the Brief re-assignment request?\n Once the brief has been re-assigned, it will not be visible in the current cluster.`,
      TOAST_SUCCESS: "Brief reassignment has been successfully approved",
    },
    REJECT_POPUP: {
      TITLE1: "Reject Brief ",
      TITLE2: " Re-assignment",
      PROMPT_TEXT: `Are you sure you want to reject the Brief re-assignment request?`,
      TOAST_SUCCESS: "Brief reassignment has been successfully rejected",
    },
  },
  PROPOSAL_REASSIGN: {
    ARPPOVE_POPUP: {
      TITLE1: "Approve Proposal ",
      TITLE2: " Re-assignment",
      PROMPT_TEXT: `Are you sure you want to approve the proposal re-assignment request?\n Once the proposal has been re-assigned, it will not be visible in the current cluster.`,
      TOAST_SUCCESS: "Proposal Re-assign  has been successfully approved",
    },
    REJECT_POPUP: {
      TITLE1: "Reject Proposal ",
      TITLE2: " Re-assignment",
      PROMPT_TEXT: `Are you sure you want to reject the Proposal re-assignment request?`,
      TOAST_SUCCESS: "Proposal Re-assign has been successfully rejected",
    },
  },
  BRIEF_SHELVE: {
    ARPPOVE_POPUP: {
      TITLE1: "Approve Brief ",
      TITLE2: " Shelve",
      PROMPT_TEXT: `Are you sure you want to approve the Brief Shelve request?\nThe shelved brief expires after 90 days. The brief can only be shelved once.`,
      TOAST_SUCCESS: "Brief Shelve has been successfully approved",
    },
    REJECT_POPUP: {
      TITLE1: "Reject Brief ",
      TITLE2: " Shelve",
      PROMPT_TEXT: `Are you sure you want to reject the Brief Shelve request?`,
      TOAST_SUCCESS: "Brief Shelve has been successfully rejected",
    },
  },
  USER_APPROVAL: {
    ARPPOVE_POPUP: {
      TITLE: "Approve user",
      PROMPT_TEXT1: `Are you sure you want to approve the user : `,
      PROMPT_TEXT2: `Once approved, the user will be part of Cluster : `,
      TOAST_SUCCESS: "User has been successfully approved",
    },
    REJECT_POPUP: {
      TITLE: "Reject user",
      PROMPT_TEXT: `Are you sure you want to reject the user : `,
      TOAST_SUCCESS: "User has been rejected",
    },
  },
  SENIOR_MANAGER: {
    CE_EVALUATION: "CE Evaluation",
    SCORE: "Score : ",
    SHOW_SCORES_TEXT: "Show Score",
    HIDE_SCORE_TEXT: "Hide Scores",
    SCORE_DESCRIPTION:
      "Characters can have more depth. The character development arc planned for the 2 main characters can be developed further to increase the intensity and longetivity of the show.",
    EVALUATION_CRITERIA: "Evaluation Criteria",
    FINAL_SCORE: "Final Score : ",
    SCORING_STATUS: "Scoring Status : ",
    SUBMIT_BTN_TEXT: "Submit",
    COMMENTS: "Comments",
    CE_EVALUATION_DEADLINE: "CE Evaluation Deadline",
    SM_EVALUATION_DEADLINE: "SM Evalauation Deadline",
    SM_EVALUATION: "Senior Manager Evaluation",
    DEADLIN_PLACE_HOLDER: "Eg. 25 Feb 2025",
    OPTIONS: {
      RE_WORK: "Re-work",
      INVITE_TO_MANAGEMENT_PITCH: "Invite to Management Pitch",
      UNSUCCESSFUL: "Unsuccessful",
    },

    TEXT_AREA_ERROR: "Please enter comments.",
    CE_DEADLINE_ERROR_MSG: "Please select CE Deadline",
    SM_DEADLINE_ERROR_MSG: "Please select SM DeadLine",
    SUBMIT_BTN_TOAST_SUCCESS_MSG: "Proposal review has been submitted successfully",
    POPUP: {
      RE_WORK: {
        TITLE: "Confirm Evaluation - Re-work",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
      INVITE_TO_MANAGEMENT_PITCH: {
        TITLE: "Confirm Evaluation - Invite to Management Pitch",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
      UNSUCCESSFUL: {
        TITLE: "Confirm Evaluation - Unsuccessful ",
        DESCRIPTION: "Are you sure you would like to submit this evaluation?",
        BUTTON_TEXT: "Submit",
      },
      cross: {
        TITLE: "Abort Review Proposal",
        DESCRIPTION: "Are you sure you would like to abort the process of Reviewing Proposal?",
        BUTTON_TEXT: "Abort",
      },
      Retry: {
        TITLE: "Review Proposal Submission Failed",
        DESCRIPTION:
          "There was an error with your review proposal submission. Please try again. We are sorry for the inconvenience.",
        BUTTON_TEXT: "Retry",
      },
    },
    REVIEW_PROPOSAL: "Review Proposal",
    BRIEF_DETAILS: "Brief Details",
    EVALUATED_ON: "Evaluated on : ",
  },
  REVIEW_PROPOSALS: {
    REVIEW_PROPOSAL_TITLE: "Review Proposal  #P-073483 - Untold Mysteries",
    BRIEF_DETAILS_TITLE: "Brief Details",
    PROPOSAL_DETAILS_TITLE: "Proposal Details",
    EVALUATION_TITLE: "Evaluation",
    SUBMIT_REVIEW: "Submit Review",
    INSTRUCTION_FOR_EVALUATION: "Instruction for Evaluation",
    INSTRUCTION_BULLET_TITLE:
      "Please provide a score for each category listed below on a scale of 0-10, where:",
    INSTRUCTION_BULLET_0: "0 indicates the lowest possible score.",
    INSTRUCTION_BULLET_1: "10 indicates the highest possible score",
    INSTRUCTION_BULLET_2: "7 is considered a good score.",
    INSTRUCTION_END_TITLE:
      "Ensure you evaluate each category thoroughly and provide a score for all listed fields. You may also add any additional comments if necessary in the form field provided.",
    EVALUATION_ORIGINALITY_TITLE: "Originality",
    EVALUATION_CLARITY_TITLE: "Clarity",
    EVALUATION_NARRATIVE_PACE_TITLE: "Narrative Pace",
    EVALUATION_CHARACTERS_TITLE: "Characters",
    EVALUATION_RELEVANCE_TITLE: "Relevance",
    EVALUATION_CREATIVITY_TITLE: "Creativity",
    EVALUATION_EMOTIONAL_IMPACT_TITLE: "Emotional Impact",
    EVALUATION_TECHNICALITY_TITLE: "Technicality",
    EVALUATION_QUALITY_TITLE: "Quality",
    EVALUATION_CONSISTENCY_TITLE: "Consistency",
    COMMENTS_TITLE: "Comments (optional)",
    COMMENTS_PLACEHOLDER:
      "The proposal shows strong potential with a unique concept and clear audience alignment. While compelling, the budget and feasibility of certain elements need refinement. A more detailed competitor analysis could further strengthen its viability.",
    SUBMIT_REVIEW_PROPOSAL: "Submit Proposal Review",
    SUBMIT_REVIEW_PROPOSAL_DESC:
      "Are you sure you want to this submit review? Once submitted, the review cannot be edited. Please ensure that scores entered are accurate.",
    EVALUVALUTION_MIN_VALUE: 0,
    EVALUVALUTION_MAX_VALUE: 10,
    CALCULATE_FINAL_SCORE: "Calculate Final Score",
    FINAL_SCORE_TITLE: "Final Score",
    REVIEW_SUBMISSION_FAILED: "Review Proposal Submission Failed",
    REVIEW_SUBMISSION_FAILED_DESC:
      "There was an error with your review proposal submission. Please enter your details and try again. We are sorry for the inconvenience.",
    RETRY_SUBMISSION: "Retry",
    VALIDATION_ERROR: "Please enter a number from 0 to 10",
  },
  COMMISSIONG_EDITORS: "Commissioning Editors",
  EVALUATION_PROCESS: "Evaluation Process",
  EVALUATION_CRITERIA: "Evaluation Criteria",
  ASSIGN_PROPOSLS: "Assign Proposal",
  CONTEXTUAL_REFERANCE: "Eg. Contextual relevance",
  ADD_MORE_CRITERIAN: "+ Add more criterian",
  EVALUATION_INFORMATION_PLACEHOLDER: "Proposal shall be evaluated based on... ",
  ASSIGN_PROPOSAL_ERROR: {
    COMMISSION_EDITORS: "Please select commission editiors",
    EVALUATION_PROCESS: "Please enter evaluation process",
  },
  REJECT_PROPOSAL: {
    TITLE: "Reject Proposal",
    BUTTON_TEXT: "Reject Proposal",
    MESSAGE:
      "Are you sure you want to reject this proposal? Once rejected, this action can’t be undone. A mail will be sent to inform the producer of their unsuccessful proposal.",
    TOAST_SUCCESS: "Proposal has been successfully rejected",
    POPUP_EMAIL_HEADER:
      "Thank you for submitting your proposal. We appreciate the time and effort put into developing this concept. After careful consideration, we will not be proceeding with your submission.",
  },
  ASSIGN_PROPOSAL_TOAST_SUCCESS: "Proposal has been successfully assigned to CEs",
  ABORT_UNSOLICATED_PROPOSAL_TITLE: "Abort Assigning Proposal",
  ABORT_UNSOLICATED_PROPOSAL_MESSAGE:
    "Are you sure you would like to abort the process of Assigning Proposal? All the data entered so far will be lost.",
  ABORT_UNSOLICATED_BUTTON: "Abort Proposal",
  SM_EVALUATION_POPUP: {
    TITLE: "Assign Proposal to Senior Managers",
    MESSAGE:
      "Are you sure you would like to assign this proposal to Senior Managers of your cluster?",
  },
  HOP_EVALUATION_POPUP:{
    TITLE:"Assign Proposal to HOP",
    MESSAGE:"Are you sure you would like to assign this proposal to HOP?",
  },
  CE_POPUP_MESSAGE: "Are you sure you would like to assign this proposal to selected Commissioning Editors in your cluster?",
  PROGRESS_LOADER_TEXT: "Your request is being processed, please wait.",
  SUPPORTED_VIDEO_FORMATS: ['video/mp4'],
  SUPPORTED_PDF_DOC_FILES: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/pdf", "application/vnd.openxmlformats-officedocument.presentationml.presentation,application/ppt,application/pptx"],
  SM_TOAST_SUCCESS: "Proposal has been assigned to Senior Managers successfully",
  HOP_TOAST_SUCCESS:"Proposal has been assigned to HOP successfully",
  ABORT_UNSOLICATED_BUTTON: "Abort Proposal",
  ADMIN: {
    USERS: 'Users',
    COMPANIES: 'Companies',
    INDIVIDUALS: 'Individuals',
    APPROVALS_OLD: 'Approvals',
    APPROVALS: 'Registered Producers',
    PRODUCERS: 'Producers',
    SEARCHCOMPANY: 'Search Company Name',
    SEARCHINDIVIDUAL: 'Search Name',
  },
  POPUP_EMAIL_HEADER: "Dear Producer,\n ",
  POPUP_EMAIL_FOOTER: "Regards,\n Content Co-ordinator",
  POPUP_EMAIL_PLACEHOLDER: "Enter your comments here",
  EMAIL_QUERY_STRING: "For login queries or assistance, please reach out to ",
  EMAIL_QUERY: "multichoicesubmissions@mnet.co.za",
  NA: "NA",
  SECRET_KEY: "mc@123321@cm",
  SESSIONOUT_HEADER: "Session Timeout",
  SESSIONOUT_CONTENT_TEXT: `You weren’t clicking around anymore, so we logged you out for your protection. To
                get back in, please login again!`,
  SESSIONOUT_ACTION_BTN: "Login",
  COMMISSIONINGEDITOR: "CE",
  CONTENTCOORDINATOR: "CC",
  SENIORMANAGER: "SM",
  FETCH_CHANNEL: "CHANNEL",
  NEW_REJECTION_EMAIL_PROPS: {
    GENERIC_CONTENT:
      "Thank you for your submission. Unfortunately, your proposal has been unsuccessful as we have already received submissions of a similar nature and/or already have similar concepts in development.",
    EMAIL_CONTENT_LABEL: "E-mail Content",
    REASON_SELECTION_SECTION_LABEL: "Reason for Rejection",
    REASON_1_LABEL: "Unsuccessful",
    REASON_2_LABEL: "Lacks Originality",
    REASON_2_MAIL_CONTENT: `Dear Producer,\n\nThank you for your submission. Unfortunately, your proposal has been unsuccessful as we have already received submissions of a similar nature and/or already have similar concepts in development.\n\nRegards,\nContent Co-ordinator`,
    REASON_1_MAIL_CONTENT: `Dear Producer,\n\nThank you for your submission. Unfortunately, your proposal has been unsuccessful as it does not meet our programming requirements and channel strategy.\n\nRegards,\nContent Co-ordinator`,
  },
  NEW_ACCEPTED_EMAIL_PROPS: {
    ACCEPTED_BY: "Acceptance By",
    EMAIL_CONTENT:
      "Dear Producer,\n\nCongratulations! Your proposal has been successful. A Commissioning Editor or Content Coordinator will engage with you within due course to discuss the next steps. \n\nRegards,\nContent Co-ordinator",
  },
  NEW_REWORK_EMAIL_CONTENT:
    "Dear Producer,\n\nThank you for submitting your proposal. We appreciate the time and effort put into developing this concept. We would like to recommend changes which will be emailed to you directly. \n\nRegards,\nContent Co-ordinator",
  NEW_IN_MANAGEMENT_PITCH_EMAIL_CONTENT:
    "Dear Producer,\n\nThank you for attending the Virtual Pitch. We would like to proceed to the second phase of the pitching process and invite you to present for Management Pitch. \n\nRegards,\nContent Co-ordinator",
  NEW_VIRTUAL_PITCH_EMAIL_CONTENT:
    "Dear Producer,\n\nThank you for submitting your proposal. We would like to proceed to the first phase of the pitching process and invite you to attend a virtual pitch. \n\nRegards,\nContent Co-ordinator",
  ROLE: "Role",
  INTERNAL_USERS_ROLE_LIST: "Internal User (CC, CE, SM)",
  SYS_ADMIN_ROLE: "System Admin",
  USER_ROLES_NAMES: {
    CC: "Content Co-Ordinator",
    CE: "Commissioning Editor",
    SM: "Senior Manager",
    SYS_ADMIN: "System Admin",
    HOP: "Head Of Production"
  },
  COMPANY_PROFILE: "Company Profile",
  CREATE_NEW_BRIEF_ERROR_MESSAGES: {
    CHANNEL: "Please select a channel",
    LANGUAGE: "Please select a language",
    GENRE: "Please select a genre",
    FORMAT: "Please select a format",
    PRODUCTION_TYPE: "Please select a production type",
    DESCRIPTION: "Please enter a description",
    SUBMISSION_REQUIREMENT: "Please enter the submission requirements",
    CLOSING_DATE: "Please select a closing date",
    CE_LIST: "Please select at least one commissioning editor",
    CE_EVAL_DEADLINE: "Please select the commissioning editor evaluation deadline",
    SM_EVAL_DEADLINE: "Please select the senior manager evaluation deadline",
    EVAL_PROCESS: "Please enter the evaluation process",
    EVAL_CRITERIA: "Please select at least one evaluation criterion",
    PRODUCER_LIST: "Please select at least one producer"
  },
  TICKETS_STATUS: {
    ALL:"All",
    ACTIVE:"Active",
    RESOLVED:"Resolved",
    TODAY:"Today",
    ONEWEEK:"1 week",
    ONEMONTH: "1 month",
    SIXMONTHS: "6 months",
    ONEYEAR: "1 year",
    GREATERTHANONEYEAR: "> 1 year",
  },
  TICKETS_FILTER: {
    TICKETS:"Tickets",
  },
  TICKETS_DETAIL: {
    TICKET_NO: "Ticket No.",
    PRODUCER:"Producer",
    TICKET_TYPE:"Ticket Type",
    PROPOSAL_NO:"Proposal No.",
    CREATED_ON:"Created on",
    RESOLVED_ON:"Resolved on",
    STATUS:"Status",
    TICKET_DETAILS_PLACEHOLDER:"Please describe your concern in detail here.",
    BRIEF_NO:"Brief No.",
    CATEGORY: "Category"
  },
  TICKET_TYPE: {
    TICKETS_TYPE: "Tickets Type",
    PROPOSAL:"Proposal",
    BRIEF:"Brief",
    OTHER: "Other",
    OTHER_CATEGORY:"Other - Category"
  },
  TICKET_STATUS_TYPE: {
    ACTIVE: "Active",
    RESOLVED:"Resolved",
    ALL:"All",
  },
  RAISE_TICKET: {
    POPUP: {
      cross: {
        TITLE: "Discard ticket without saving",
        MESSAGE:
          "Are you sure you would like to discard the ticket without saving? Once discarded the ticket can no longer be retrieved",
        BUTTON_TEXT: "Discard",
      },
      submit: {
        TITLE: "Confirm Ticket Submission",
        MESSAGE:'Are you sure you would like to submit a ticket?',
        BUTTON_TEXT: "Submit"
      }
    },
    SUBMIT_BUTTON: "Submit",
    CANCEL_BUTTON: "Cancel",
    SUBMIT_BTN_TOAST_SUCCESS_MSG:"Ticket has been submitted successfully",
    RESOLVE_BTN_TOAST_SUCCESS_MSG:"Ticket has been resolved successfully",
  },
  AUDITTRAIL:{
    PROPOSALS:"Proposal Audit Trail",
    BRIEFS:"Briefs Audit Trail",
    SEARCH_PROPOSALS:"Search Proposal",
    SEARCH_BRIEF:"Search Brief",
    FILTERACTIONBY:'Action By',
    FILTERCLUSTER:'Cluster',
    CLOSEVIEWCOMMENTS:'Close',
    VIEWCOMMENTSACTION:'Action :',
    VIEWCOMMENTSPROPOSAL:'Proposal :',
    VIEWCOMMENTSBRIEF:'Brief :',
    VIEWCOMMENTSACTIONBY:'Action by : ',
    VIEWCOMMENTSCOMMENT:'Comment :',
    VIEWCOMMENTRECLUSTER:'Re-assigned Cluster :',
    VIEWCOMMENTRECHANNEL:'Re-assigned Channel :',
    DATE_180DAYSERROR:"The date range between 'From' and 'To' should not exceed 180 days.",
  },
  MANDATORY_FIELD_TEXT: " Mandatory Field",
  DEFAULT_MIN_DATE: "0001-01-01T23:59:59",
  NO_DATA_AVAILABLE: "No data available",
  PRODUCER: {
    DASHBOARD: "Dashboard",
    UNSOLICITEDPROPOSAL: "+ Unsolicited Proposal",
    NEWBRIEF: "+ New Brief",
    ALLPROPOSALS: "All Proposals",
    MYPROPOSALS: "My Proposals",
    ACTIVEBRIEF: "Active Briefs",
    BRIEFS: "Briefs",
    BRIEFRECEIEVED: "Briefs Received",
    OPEN: "Open",
    CLOSED: "Closed",
    FILTERBY: "Filter by",
    CLEARALL: "Clear All",
    VIEWAPPLY: "View and Apply",
    SEARCH: "Search",
    SOLICITEDBRIEF: "Solicited Briefs",
  },
  TABLE_HEADERS: {
    PROPOSALNO: "Proposal No.",
    BRIEFREFNO: "Brief Ref. No.",
    REGNO: "Registration No.",
    CHANNEL: "Channel",
    COMPANYNAME: "Company Name",
    NAME: "Name",
    DESIGNATION: "Designation",
    CREATEDBY: "Created By",
    CONTACT_NAME: "Contact Name",
    EMAIL: "Email",
    COUNTRY: "Country",
    GENRE: "Genre",
    CLUSTER: "Cluster",
    REPORTINGTO: "Reporting To",
    PHONENUMBER: "Phone Number",
    SCRIPTEDNONSCRIPTED: "Scripted / Non-Scripted",
    APPROVALSCORE: "Approval Score",
    CLOSINGDATE: "Closing Date & Time (CAT)",
    REGDATE: "Registration Date & Time (CAT)",
    CREATIONDATE: "Creation Date & Time (CAT)",
    STATUS: "Status",
    PROPOSALTITLE: "Proposal Title",
    TYPE: "Type",
    APPLICATIONDATE: "Application Date & Time (CAT)",
    REASSIGNCLUSTER: "Re-assigned Cluster",
    REASSIGNCHANNEL: "Re-assigned Channel",
    SHELVEREQUESTEDBY: "Shelve Requested by",
    REASSIGNREQUESTEDBY: "Re-assign Requested by",
    REQUESTEDBY: "Requested by",
    REQUESTEDATE: "Requested Date (CAT)",
    PROPOSALREFNO: "Proposal Ref. No",
    PRODUCER: "Producer",
    EMPID: "Employee ID",
    EMPNAME: "Employee Name",
    ROLE: "Role",
    APPORVEREJECT: "Approve / Reject",
    BRIEFSTATUS: "Brief Status",
    ACTION: "Action",
    ACTIONDATE: "Action Date & Time (CAT)",
    ACTIONBY: "Action By",
    BRIEFNO: "Brief No.",
    COMMENTIFANY: "Comment (If Applicable)",
    VIEWCOMMENTS: "View Comment",
  },
  HEADER: {
    DASHBOARD: "Dashboard",
    MYPROPOSALS: "My Proposals",
    INTERNALMANAGEMENT: "Internal Management",
    ALLPROPOSALS: "All Proposals",
    REQUESTS: "Requests",
    AUDITTRAIL: "Audit Trail",
    PRODUCER: "PRODUCER",
    ROLE: "Role",
    LOGOUT: "Logout",
  },
  INTERNAL: {
    SEARCHBRIEFNO: 'Search Brief No.',
    BRIEFNO: 'Brief No./Proposal No./Title',
    PROPOSALTITLENO: "Proposal No./Title",
    NEWCLUSTER: "New Cluster",
    NEWUSER: "New User",
    SEARCHCLUSTER: "Search Cluster",
    SEARCHUSER: "Search User",
    SAVE: 'Save',
    INDIVIDUALPRODUCERPROFILE: 'Individual Producer Profile',
    PRODUCERINFO: 'Producer Information',
    VERSION: "Version :",
  },
  UPDATE_CE_LIST_SUCCESS: "CE List has been modified successful",
  UPDATE_CE_LIST_FAILURE: "Error : Action was unsuccessful. Please try again.",
  SOUTH_AFRICA:"South Africa",
  HOP_CHANNEL_HEAD_ROLE_LIST:"HOP",
  HEADOFPRODUCTION:"HOP",
  TICKETS_PAGE: {
    TICKET_TYPE:"Type of Ticket",
    TICKET_NOTE_TEXT: "Note: A ticket may be raised to reach out to the Multichoice Content team in case a Producer would like to address a concern regarding their proposal or a brief published on the portal. Please refer to the FAQ section for portal-related queries.",
    PROPOSAL_DROPDOWN_PLACEHOLDER: "Eg. Proposal No. / Title",
    DETAILS_OF_THE_TICKET: "Details of the Ticket",
    BRIEF_DROPDOWN_PLACEHOLDER: "Eg. Brief No.",
    UPLOAD_REFERENCE_PLACEHOLDER: "Upload Reference Images (If Any)",
    OTHER_DROPDOWN_PLACEHOLDER: "Eg. Technical Issue",
    RAISE_A_TICKET: "Raise a Ticket",
    VIEW_TICKET: "View Ticket",
    DASHBOARD: "Dashboard",
    REFERENCE_IMAGE: "Reference Image",
    PRODUCER_CONTACT_INFORMATION: "Producer Contact Information",
    PROVIENCE: "Province",
    OTHERS_TECHNICAL_ISSUE: "Others - Technical Issue",
    OTHERS_GENERAL_INQUIRY: "Others - General Inquiry",
    OTHERS_ACCOUNT_RELATED: "Others - Account Related"
  },
  CLUSTERNAME: {
    ANGOLANONSCRIPTED: "Angola Non-Scripted",
    ANGOLASCRIPTED: "Angola Scripted",
    BOTSWANANONSCRIPTED: "Botswana Non-Scripted",
    BOTSWANASCRIPTED: "Botswana Scripted",
    CAMEROONNONSCRIPTED: "Cameroon Non-Scripted",
    CAMEROONSCRIPTED: "Cameroon Scripted",
    ETHIOPIANONSCRIPTED: "Ethiopia Non-Scripted",
    ETHIOPIASCRIPTED: "Ethiopia Scripted",
    GHANANONSCRIPTED: "Ghana Non-Scripted",
    GHANASCRIPTED: "Ghana Scripted",
    KENYANONSCRIPTED: "Kenya Non-Scripted",
    KENYASCRIPTED: "Kenya Scripted",
    LESOTHONONSCRIPTED: "Lesotho Non-Scripted",
    LESOTHOSCRIPTED: "Lesotho Scripted",
    MALAWISCRIPTED: "Malawi Scripted",
    MOZAMBIQUENONSCRIPTED: "Mozambique Non-Scripted",
    MOZAMBIQUESCRIPTED: "Mozambique Scripted",
    NAMIBIANONSCRIPTED: "Namibia Non-Scripted",
    NAMIBIASCRIPTED: "Namibia Scripted",
    NIGERIANONSCRIPTED: "Nigeria Non-Scripted",
    NIGERIASCRIPTED: "Nigeria Scripted",
    SOUTHAFRICAMIDDLEMASSNONSCRIPTED: "South Africa Middle & Mass Non-Scripted",
    SOUTHAFRICAMIDDLEMASSSCRIPTED: "South Africa Middle & Mass Scripted",
    SOUTHAFRICAPREMIUMNONSCRIPTED: "South Africa Premium Non-Scripted",
    SOUTHAFRICAPREMIUMSCRIPTED: "South Africa Premium Scripted",
    TANZANIANONSCRIPTED: "Tanzania Non-Scripted",
    TANZANIASCRIPTED: "Tanzania Scripted",
    UGANDANONSCRIPTED: "Uganda Non-Scripted",
    UGANDASCRIPTED: "Uganda Scripted",
    ZAMBIANONSCRIPTED: "Zambia Non-Scripted",
    ZAMBIASCRIPTED: "Zambia Scripted",
    ZIMBABWENONSCRIPTED: "Zimbabwe Non-Scripted",
    ZIMBABWESCRIPTED: "Zimbabwe Scripted",
    UNSCRIPTEDAFRIKAANSPREMIUM:"Unscripted Afrikaans Premium",
    SCRIPTEDAFRIKAANSPREMIUM:"Scripted Afrikaans Premium"
  },
  ROLENAME: {
    SYSTEMADMIN: "System Admin",
    COMMISSIONINGEDITOR: "Commissioning Editor",
    CONTENTCOORDINATOR: "Content Co-Ordinator",
    PRODUCER: "Producer",
    SENIORMANAGER: "Senior Manager",
  },
  MANDATORY_FIELD_TEXT: " Mandatory Field",
  NO_STATUS: "No status histories available.",
  HALFSCREEN: {
    PRODUCER_TYPE: {
      INDIVIDUAL: "Individual",
    },
    PROPOSAL_TYPE: {
      SOLICITED: "Solicited",
      UNSOLICITED: "Unsolicited",
    },
    FORMAT_TYPE: {
      M: 'M',
      E: 'E'
    },
    STATUS: {
      COMPLETED: "Completed",
      IN_CE_REVIEW: "In CE Review",
      IN_SM_REVIEW: "In SM Review",
      UNSUCCESSFUL: "Unsuccessful",
      ACCEPTED: "Accepted",
      UNKNOWN_STATUS: "Unknown Status",
      RE_WORK: "Re-work",
      EDIT_PROPOSAL: "Edit Proposal"
    },
    VIEW_LESS: "View Less",
    VIEW_MORE: "View More",
    NA: "N/A",
    RELOAD_BTN: "Reload",
    PRESENTS: " presents",
    DOCUMENT: "Document",
    DESCRIPTION: "Description",
    SUBMISSION_REQUIREMENTS: "Submission Requirements",
    STATUS_IMAGE: "Status Image",
    TIME_ON: "on",
    NO_STATUS_HISTORY: "No status histories available.",
    UNSOLICITED: "Unsolicited",
    CE_LABEL: "Commissioning \n Editiors"
  },
    SOCIAL_MEDIA_1:"SocialMedia1",
    SOCIAL_MEDIA_2:"SocialMedia2",
    SOCIAL_MEDIA_3:"SocialMedia3",
    YES:"Yes",
    NO:"No",
    WEBSITE_LINK:"WebsiteLink",
    en:"English",
    afk:"Afrikaans",
    pt:"Portuguese",
    kw:"Kiswahili",
    ah:"Ahmaric",
  APPLY_BRIEF_LABELS: {
    PROPOSAL_TITLE: "Proposal Title",
    LOGLINE: "Logline",
    SYNOPSIS: "Synopsis",
    EDITORIAL_DETAILS: "Editorial Details",
    LOOKBOOK: "Lookbook and Moodboard ( .pdf or .doc or .ppt )",
    CURRENCY: "Currency",
    PRELIMINARY_BUDGET: "Preliminary Budget",
    PICTCH_DECK: "Pitch Deck ( .pdf or .doc or .ppt )",
    LOCATION_STUDIO: "Location and Studio Information",
    CAST_PRESENTER: "Cast and Presenter Information",
    BRAND_INTEGRATION: "Brand Integration Opportunities",
    COMPANY_PROFILE: "Company Profile and Team Details",
  SOCIAL_MEDIA_1: "SocialMedia1",
  SOCIAL_MEDIA_2: "SocialMedia2",
  SOCIAL_MEDIA_3: "SocialMedia3",
  YES: "Yes",
  NO: "No",
  WEBSITE_LINK: "WebsiteLink",
  en: "English",
  afk: "Afrikaans",
  port: "Portuguese"
  },
  CHANNEL_NAME: {
    ABOLTV: "Abol TV",
    ABOLDUKA: "Abol Duka",
    AKWAABAMAGIC: "Akwaaba Magic",
    AFRICAMAGIC: "Africa Magic",
    AFRICAMAGICSHOWCASE: "Africa Magic Showcase",
    AFRICAMAGICFAMILY: "Africa Magic Family",
    CHANNELO: "Channel O",
    KWENDAMAGIC: "Kwenda Magic",
    KYKNET: "KykNet",
    KYKNETKIE: "Kyk&Kie",
    KYKNETNOU: "KykNET Nou",
    MAADIIABOL: "Maadii Abol",
    MAISHAMAGICBONGO: "Maisha Magic Bongo",
    MAISHAMAGICEAST: "Maisha Magic East",
    MAISHAMAGICPLUS: "Maisha Magic Plus",
    MAISHAMAGICPOA: "Maisha Magic POA",
    MANINGUEKOOL: "Maningue Kool",
    MANINGUEMAGIC: "Maningue Magic",
    MNET: "Mnet",
    MNETMOVIES: "Mnet Movies",
    MZANSIMAGIC: "Mzansi Magic",
    MZANSIWETHU: "Mzansi Wethu",
    ONEZED: "One Zed",
    PEARLMAGIC: "Pearl Magic",
    PEARLMAGICPRIME: "Pearl Magic Prime",
    SHOWMAX: "Showmax",
    ZAMBEZIMAGIC: "Zambezi Magic",
  },
  CHECKDROPDOWN:{
    SELECTALL:  'Select All',
    NORESULTFOUND: 'No results found'
  },
  LANGUAGE_KEYS:{
    ENGLISH:'en',
    KISWAHILI:'kw',
    AHMARIC:'ah',
    PORTUGESE:'pt'
  },
  REQUESTSEARCH:{
    SEACHBREIFNO:"Search Brief No.",
    SEARCHPROPOSALNO:"Search Proposal No.",
  },
  NOTIFICATIONS:{
      OLDER:"Older",
      TODAY:"Today",
  },
  DOWNLOADPDFWORD:{
    WORD:'Word Doc',
    PDF:'PDF',
  },
  SOLICITED_BRIEFS: {
    DESCRIPTION: "Description",
    SUBMISSION_REQUIREMENTS: "Submission Requirements",
    EVALUATION_PROCESS: "Evaluation Process"
  },
  PROPOSAL_DETAILS:"Proposal Details",
  PROPOSAL_DETAILS_KEYS: {
  "Country": "Country",
  "Genre": "Genre",
  "Channel": "Channel",
  "Language": "Language",
  "Production Type": "Production Type",
  "Format": "Format",
  "Proposal Title": "Proposal Title",
  "Synopsis": "Synopsis",
  "Logline": "Logline",
  "Episode Structure and outline": "Episode Structure and outline",
  "Currency": "Currency",
  "Target Budget": "Target Budget",
  "Locations and Studio Information": "Locations and Studio Information",
  "Cast and Presenter Information": "Cast and Presenter Information",
  "Brand Integration Opportunities": "Brand Integration Opportunities",
  "Project Status": "Project Status",
  "Key Teams": "Key Teams",
  "Artist Name": "Artist Name",
  "Song Name": "Song Name",
  "Reference Links": "Reference Links",
  "Total Duration": "Total Duration (in mins)",
  "Scripted / Non-Scripted": "Scripted /\n Non-Scripted"
},
SHELVE_DETAILS:"Shelve Details",
RE_ASSIGNMENT_DETAILS:"Re-assignment Details",
CE_EVALUATION_ACCORDION_TITLE: "CE Evaluation",
FAVOURITES:"Favourites",
TICKET:"Ticket",
HOP_EVALUATION: "Head of Production Evaluation",
LOOKBOOK_ERROR:"Please enter lookbook and moodboard is required",
SM_EVAL_COMMENTS_PLACEHOLDER:"Write up to 1024 characters...",
SEARCH_MIN_3_CHAR:"Search (min 3 characters)",
SELECT_MONTH_YEAR:"Select a month and year",
NO_CE_FOUND:"No Commissioning Editors found.",

CE_EVAL_SAVE_AS_DRAFT_POPUP_TITLE: "Save Evaluation as Draft",
CE_EVAL_SAVE_AS_DRAFT_POPUP_MESSAGE: "Are you sure you would like to save this evaluation as a draft?",
CE_EVAL_SAVE_AS_DRAFT_BUTTON_TEXT: "Save as Draft",
CE_EVAL_SAVE_AS_DRAFT_TOAST_SUCCESS_MSG: "CE Evaluation has been successfully saved as draft.",
CE_EVAL_SAVE_AS_DRAFT_TOAST_FAILURE_MSG: "Failed to save CE Evaluation as draft. Please try again.",
CE_EVAL_SAVE_AS_DRAFT_ERROR_POPUP_MSG: "We couldn’t save your evaluation draft due to an error. Please try again. We apologize for the inconvenience.",
CE_EVAL_SAVE_AS_DRAFT_ERROR_POPUP_TITLE: "Failed to Save CE Evaluation",
REVIEW_PROPOSAL:"Review Proposal",
PROFILE_UPDATE_ERROR_POPUP_TITLE:"Update Profile Failed",
PROFILE_UPDATE_ERROR_POPUP_TEXT:"There was an error with the update of your profile. Please try again",
FILE_ERROR_PART1:"Please upload a",
FILE_ERROR_PART2:" file format.",
MIN_FILE_SIZE_ERROR:"File size should be greater than 0MB",
MAX_FILE_SIZE_ERROR:"The file size exceeds the 500MB limit. Please upload a smaller file.",
HALF_PAGE_REFERENCE_LINK:"Reference Link",
FROM:"From",
TO:"To",
BY:"by",
PASSED:"Passed",
FAILED:"Failed",
SOCIAL_MEDIA:"Social Media"
};